<template>
     <header id="header">
        <div class="logo"><img src="/images/logo_ttm.png" alt="TTM SOFT"></div>
        
        <nav class="pc-nav">
            <ul id="nav-links">
                <li><a href="#home" class="main-link active">Home</a></li>
                <li><a href="#about" class="main-link">About</a></li>
                
                <li class="has-dropdown">
                    <a href="#ai-solution" class="main-link" id="ai-nav-link">AI Solution <span style="font-size: 10px; vertical-align: middle; margin-left: 3px;">▼</span></a>
                    <ul class="dropdown">
                        
                        <li><a href="#" class="ai-sub-link" data-tab="ai-2">AI기반 규제정보 네비게이터 챗봇, RegNavigator AI(ver1.5)</a></li>
                        <li><a href="#" class="ai-sub-link" data-tab="ai-3">AI기반 영어 학습 튜터 플랫폼, 영어 AI 튜터(ver1.2)</a></li>
                        <li><a href="#" class="ai-sub-link" data-tab="ai-4">AI기반 이력서/자기소개서 자동 생성 도우미, 이력서도우미(ver1.6)</a></li>
                        <li><a href="#" class="ai-sub-link" data-tab="ai-1">유망기술 AI 솔루션</a></li>
                        <li><a href="#" class="ai-sub-link" data-tab="ai-5">AI기반 LMS학습관리시스템 문제 자동 생성기(ver2.1)</a></li>
                        <li><a href="#" class="ai-sub-link" data-tab="ai-6">AI 웹사이트 개인정보(PII) 스캔 솔루션(ver1.7)</a></li>
                        <li><a href="#" class="ai-sub-link" data-tab="ai-7">HWP 문서 AI 요약, 생성기 솔루션(ver1.2)</a></li>
                    </ul>
                </li>
                
                <li><a href="#business" class="main-link">Business</a></li>
                <li><a href="#location" class="main-link">Location</a></li>
            </ul>
        </nav>

        <div class="hamburger-menu" id="hamburgerMenu">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </header>

    <div class="mobile-nav" id="mobileNav">
        <ul id="mobile-nav-links">
            <li><a href="#home" class="mobile-link active">Home</a></li>
            <li><a href="#about" class="mobile-link">About</a></li>
            
            <li>
                <div class="m-nav-row">
                    <a href="#ai-solution" class="mobile-link" id="m-ai-nav-link">AI Solution</a>
                    <span class="m-toggle" id="mToggleBtn">▲</span>
                </div>
                <ul class="m-dropdown active" id="mDropdown">

                    <li><a href="#" class="ai-sub-link" data-tab="ai-2">AI기반 규제정보 네비게이터 챗봇, RegNavigator AI(ver1.5)</a></li>
                    <li><a href="#" class="ai-sub-link" data-tab="ai-3">AI기반 영어 학습 튜터 플랫폼, 영어 AI 튜터(ver1.2)</a></li>
                    <li><a href="#" class="ai-sub-link" data-tab="ai-4">AI기반 이력서/자기소개서 자동 생성 도우미, 이력서도우미(ver1.6)</a></li>
                    <li><a href="#" class="ai-sub-link" data-tab="ai-1">유망기술 AI 솔루션</a></li>
                    <li><a href="#" class="ai-sub-link" data-tab="ai-5">AI기반 LMS학습관리시스템 문제 자동 생성기(ver2.1)</a></li>
                    <li><a href="#" class="ai-sub-link" data-tab="ai-6">AI 웹사이트 개인정보(PII) 스캔 솔루션(ver1.7)</a></li>
                    <li><a href="#" class="ai-sub-link" data-tab="ai-7">HWP 문서 AI 요약, 생성기 솔루션(ver1.2)</a></li>
                </ul>
            </li>
            
            <li><a href="#business" class="mobile-link">Business</a></li>
            <li><a href="#location" class="mobile-link">Location</a></li>
        </ul>
    </div>

    <section id="home">
        <div class="container">
            <h1 class="hero-title reveal-up">
                데이터로 그리는 내일, AI로 완성하는 혁신<br>
                <span style="color:var(--accent-color)">TTMSoft</span>
            </h1>
            <p class="section-desc reveal-up delay-1">
                대용량 포털서비스 및 검색 서비스 분야의 특화된 기술을 가지고 2009년 출범한 회사로서<br>
다양한 인공지능 서비스 및 클라우드, 웹 포털 서비스 구축 및 시스템 통합, AI기반 LMS/LCMS 이러닝 교육 솔루션, 실시간 기상 관제 플랫폼 구축, 기후 예측·분석 시스템 구축, 모바일 어플리케이션 개발에 주력하는 전문 기업입니다.
            </p>
        </div>
        
        <a href="#about" class="scroll-indicator">
            <span>Scroll</span>
            <div class="mouse">
                <div class="wheel"></div>
            </div>
        </a>
    </section>

    <section id="about">
        <div class="container">
            <div class="section-title reveal-up">Company <span>Overview</span></div>
            <p class="section-desc reveal-up delay-1">생활속의 인터넷을 통합하여 가치를 창조하는 TTMSoft를 소개합니다.</p>
            
            <div class="tab-btn-group reveal-up delay-2" id="about-tabs">
                <button class="sub-tab-btn active" data-target="about-intro">소개 (Overview)</button>
                <button class="sub-tab-btn" data-target="about-history">연혁 (History)</button>
            </div>

            <div class="about-content-wrapper reveal-scale">
                <div class="tab-content-area about-content active" id="about-intro">
                    <div class="intro-text-box">
                        <h3>"생활속의 인터넷을 통합 가치창조"</h3>
                        <p>대용량 포털서비스 및 검색 서비스 분야의 특화된 기술을 가지고 2009년 출범한 회사로서<br>
<strong>다양한 인공지능 서비스 및 클라우드, 웹 포털 서비스 구축 및 시스템 통합, AI기반 LMS/LCMS 이러닝 교육 솔루션, 실시간 기상 관제 플랫폼 구축, 기후 예측·분석 시스템 구축, 모바일 어플리케이션 개발</strong>에 주력하는 전문 기업입니다.</p>
                    </div>
                    
                    <div class="marquee-container pc-marquee">
                        <div class="marquee-track left">
                            <div class="marquee-box"><p>검색엔진</p></div>
                            <div class="marquee-box"><p>빅데이터</p></div>
                            <div class="marquee-box"><p>인공지능 (AI)</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>블록체인</p></div>
                            <div class="marquee-box"><p>지도위치기반 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>LMS 이러닝 시스템</p></div>
                            
                            <div class="marquee-box"><p>검색엔진</p></div>
                            <div class="marquee-box"><p>빅데이터</p></div>
                            <div class="marquee-box"><p>인공지능 (AI)</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>블록체인</p></div>
                            <div class="marquee-box"><p>지도위치기반 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>LMS 이러닝 시스템</p></div>
                        </div>

                        <div class="marquee-track right">
                            <div class="marquee-box"><p>모바일 앱 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>WMS 물류시스템</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>IoT 모니터링</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>역량진단평가</p></div>
                            <div class="marquee-box"><p>각종 소프트웨어 개발</p></div>
                            <div class="marquee-box"><p>실시간 화상교육/회의</p></div>

                            <div class="marquee-box"><p>모바일 앱 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>WMS 물류시스템</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>IoT 모니터링</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>역량진단평가</p></div>
                            <div class="marquee-box"><p>각종 소프트웨어 개발</p></div>
                            <div class="marquee-box"><p>실시간 화상교육/회의</p></div>
                        </div>
                    </div>

                    <div class="marquee-container mobile-marquee">
                        <div class="marquee-track left">
                            <div class="marquee-box"><p>검색엔진</p></div>
                            <div class="marquee-box"><p>빅데이터</p></div>
                            <div class="marquee-box"><p>인공지능 (AI)</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>블록체인</p></div>
                            <div class="marquee-box"><p>지도위치기반 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>LMS 이러닝 시스템</p></div>
                            <div class="marquee-box"><p>모바일 앱 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>WMS 물류시스템</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>IoT 모니터링</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>역량진단평가</p></div>
                            <div class="marquee-box"><p>각종 소프트웨어 개발</p></div>
                            <div class="marquee-box"><p>실시간 화상교육/회의</p></div>

                            <div class="marquee-box"><p>검색엔진</p></div>
                            <div class="marquee-box"><p>빅데이터</p></div>
                            <div class="marquee-box"><p>인공지능 (AI)</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>블록체인</p></div>
                            <div class="marquee-box"><p>지도위치기반 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>LMS 이러닝 시스템</p></div>
                            <div class="marquee-box"><p>모바일 앱 서비스</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>WMS 물류시스템</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>IoT 모니터링</p></div>
                            <div class="marquee-box"><span class="sol-badge">솔루션 보유</span><p>역량진단평가</p></div>
                            <div class="marquee-box"><p>각종 소프트웨어 개발</p></div>
                            <div class="marquee-box"><p>실시간 화상교육/회의</p></div>
                        </div>
                    </div>
                </div>

                <div class="tab-content-area about-content" id="about-history">
                    <div class="timeline">
                        <div class="timeline-item">
                            <div class="timeline-year">2026</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>기상청 기후예측-분석 통합시스템 유지관리 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 운영 및 유지관리 사업</li>
                                    <li>서울시 평생학습 포털시스템 유지보수 사업</li>
                                    <li>과학기술사업화진흥원 정보제공서비스 유지보수 사업</li>
                                    <li>한양사이버대학교 학습포털-앱 서비스 유지보수 사업</li>
                                </ul>
                            </div>
                        </div>
                        <div class="timeline-item">
                            <div class="timeline-year">2025</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>AI기반 규제정보 네비게이터 챗봇, RegNavigator AI(ver1.5) 개발</li>
                                    <li>AI기반 이력서/자기소개서 자동 생성 도우미, 이력서도우미(ver1.6) 개발</li>
                                    <li>AI 웹사이트 개인정보(PII) 스캔 솔루션(ver1.7) 개발</li>
                                    <li>HWP 문서 AI 요약, 생성기 솔루션(ver1.2) 개발</li>
                                    <li>기상청 기후예측-분석 통합시스템 개선(Ⅲ) 사업</li>
                                    <li>기상청 기후예측-분석 통합시스템 유지관리 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 운영 및 유지관리 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 기능개선 사업</li>
                                    <li>서울시 평생학습 포털시스템 유지보수 사업</li>
                                    <li>과학기술사업화진흥원 정보제공서비스 유지보수 사업</li>
                                    <li>한양사이버대학교 학습포털-앱 서비스 유지보수 사업 </li>
                                </ul>
                            </div>
                        </div>
                        <div class="timeline-item">
                            <div class="timeline-year">2024</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>AI 기반 영어 학습 튜터 플랫폼, 영어 AI 튜터(ver1.2) 개발</li>
                                    <li>AI기반 LMS학습관리시스템 문제 자동 생성기(ver2.1) 개발</li>
                                    <li>기상청 기후예측-분석 통합시스템 개선(Ⅱ) 사업</li>
                                    <li>기상청 기후예측-분석 통합시스템 유지관리 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 기능개선 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 운영 및 유지관리 사업</li>
                                    <li>서울시 평생학습 포털시스템 유지보수 사업</li>
                                    <li>서울시 평생학습 포털시스템 고도화 사업</li>
                                    <li>과학기술사업화진흥원 정보제공서비스 유지보수 사업</li>
                                    <li>AI/애자일 기반 규제법령검색 네비게이터 DPG 구축 사업 (NIA)</li>
                                    <li>Tech-Business 기술거래 매칭서비스 구축 사업</li>
                                    <li>이버드 특허법인 기술거래 플랫폼 시스템 구축 사업</li>
                                    <li>베트남 클라우드기반 온라인 한국어 학습관리시스템 구축 사업</li>
                                </ul>
                            </div>
                        </div>
                        <div class="timeline-item">
                            <div class="timeline-year">2023 ~ 2022</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>기상청 기후예측-분석 통합시스템 개선(Ⅰ) 사업</li>
                                    <li>기상청 기후예측-분석 통합시스템 유지관리 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 기능개선 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 운영 및 유지관리 사업</li>
                                    <li>(2년 장기계약) 서울시 평생학습 포털시스템 유지보수 사업</li>
                                    <li>한양사이버대학교 SSO 통합인증 및 포털시스템 재구축 사업</li>
                                    <li>기상청 기후예측-분석 통합시스템 고도화 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 기능개선 사업</li>
                                    <li>기상청 기상관측 종합관리시스템 운영 및 유지관리 사업</li>
                                    <li>기상청 이상기후전망정확도 향상 기술 개발 및 시스템 개선</li>
                                    <li>서울시 평생학습 포털시스템 유지보수 사업</li>
                                    <li>서울시 평생학습 포털시스템 통합검색 유지보수 사업</li>
                                    <li>과학기술일자리 진흥원 미래기술마당 서비스 데이터/검색 체계 고도화 및 유지보수 사업</li>
                                </ul>
                            </div>
                        </div>

                        <div class="timeline-item">
                            <div class="timeline-year">2021 ~ 2020</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>서울시 평생학습포털시스템 고도화</li>
                                    <li>서울시 평생학습포털시스템 유지보수</li>
                                    <li>서울시 평생학습포털시스템 통합검색 유지보수</li>
                                    <li>기후 예측-분석 통합시스템 구축(기상청)</li>
                                    <li>기상관측 종합관리시스템 고도화</li>
                                    <li>기상관측종합관리시스템 운영 및 유지관리</li>
                                    <li>공공데이터 구축 사업, 사업화 유망기술정보 가공 및 잠재수요기업 발굴․OPEN API 개발</li>
                                    <li>온라인 마케팅서비스 개발</li>
                                    <li>COMPA 바우처 관리시스템 개발</li>
                                    <li>한국교총 사제동행 LMS 컨텐츠 변환 사업</li>
                                    <li>공공데이터 구축 사업, 특허데이터거버넌스 구축</li>
                                    <li>2020년 지역 장기예보 생산시스템 기능 강화</li>
                                    <li>2020년 기상관측종합관리시스템 고도화</li>
                                    <li>2020년 서울시평생학습포털시스템 유지보수</li>
                                    <li>2020년 기상관측종합관리시스템 운영 및 유지관리 사업</li>
                                    <li>NIPA메타플랫폼기반연구 개발 신서비스 개발 및 확산 사업</li>
                                </ul>
                            </div>
                        </div>

                        <div class="timeline-item">
                            <div class="timeline-year">2019 ~ 2018</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>이투스 교육시스템 신규 플랫폼 구축 사업</li>
                                    <li>SC제일은행 MBS 관리시스템 재 구축 사업</li>
                                    <li>국회 예산정책처 RARIS 조사분석시스템 고도화</li>
                                    <li>SK텔레시스 OK플라자 검색엔진 기능개선</li>
                                    <li>서울시 평생학습포털시스템 기능 개선</li>
                                    <li>기상청 기상관측 통합모니터링 시스템 기능 개선</li>
                                    <li>대법원 판결서, 종합법률정보시스템 검색엔진 유지보수</li>
                                    <li>기상청 기상관측 통합모니터링 시스템 유지관리</li>
                                    <li>서울시 평생학습포털시스템 유지관리</li>
                                    <li>건강보험 심사평가원 대내외 업무시스템 개선</li>
                                    <li>SKT 빅데이터 수집처리 모듈 고도화 사업</li>
                                    <li>한국공인중개사협회 한방 모바일 서비스 재구축 사업</li>
                                    <li>기상청 기상관측 통합 모니터링시스템 고도화</li>
                                    <li>기상청 기상관측 통합모니터링 시스템 유지관리</li>
                                    <li>서울시 평생학습포털시스템 유지관리</li>
                                    <li>한국공인중개사협회 한방 앱서비스 유지관리</li>
                                </ul>
                            </div>
                        </div>

                        <div class="timeline-item">
                            <div class="timeline-year">2017 ~ 2014</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>서울시 평생학습포털 이러닝 LMS 시스템 기능개선 사업</li>
                                    <li>한국공인중개사협회 계약서 국토교통부와의 연계시스템 구축 사업</li>
                                    <li>건강보험공단 빅데이터 플랫폼 구축사업 (OLAP, MSTR)</li>
                                    <li>기상청 통합 모니터링시스템 구축 2차사업</li>
                                    <li>건강보험심사평가원 정보화 사업 (포털, 통계/분석 OLAP, MSTR)</li>
                                    <li>대한 간호협회 KNA 에듀센터서비스 구축</li>
                                    <li>동아일보 독자DB 통합고객관리 시스템 고도화</li>
                                    <li>국회 예산정책처 재정·경제데이터 및 PC,모바일 홈페이지 통합사업</li>
                                    <li>기상청 기상관측 통합메타데이터시스템 구축</li>
                                    <li>건강보험심사평가원 정보화 사업 (포털, 통계/분석 OLAP, MSTR)</li>
                                    <li>기상산업진흥원 기상신호 통합모니터링시스템 구축 (OLAP, MSTR)</li>
                                    <li>대검찰청 범죄수익환수정보시스템 유지/관리 사업</li>
                                    <li>국회 사무처 의안정보시스템 고도화 사업 참여</li>
                                    <li>WMS 물류시스템 개발 (클라우드 환경, 자체 개발환경 프레임웍 개발)</li>
                                    <li>서울시 평생교육포털 서비스 고도화 (PC웹, 모바일 하이브리드 앱)</li>
                                    <li>SK 하이닉스 역량진단 평가 시스템 개발 (Loaf 자체 프레임웍 납품)</li>
                                    <li>국회 예산정책처 개인정보보호강화 사업</li>
                                    <li>미니게이트 웅진 모바일 교육솔루션 개발 참여</li>
                                    <li>유래커뮤니케이션 모바일 전자문서관리 시스템 개발 (모바일 하이브리드앱, 자체 프레임웍 납품)</li>
                                    <li>아르바이트천국 강사닷컴 모바일 하이브리드앱 개발</li>
                                    <li>ACE생명보험 모바일 약관전달 시스템 개발 (모바일 하이브리드 앱, 자체 프레임웍 납품)</li>
                                    <li>대검찰청 2014 KICS 형사사법정보시스템 고도화 사업</li>
                                    <li>국회 예산정책처 NABO 정보시스템 구축</li>
                                    <li>한국철도공사 철도대학교 LMS 이러닝 시스템 구축 (PC웹, 모바일 웹)</li>
                                    <li>기상청 차세대 통합기상IT 인프라 COMIS4 3차년도 구축사업</li>
                                    <li>영남사이버대학교 모바일 LMS 이러닝 시스템 구축 (PC웹, 모바일 웹)</li>
                                    <li>산업인력공단 시험 / 평가 시스템 구축, 영화제작협회 ERP 시스템 유지보수</li>
                                </ul>
                            </div>
                        </div>

                        <div class="timeline-item">
                            <div class="timeline-year">2013 ~ 2009</div>
                            <div class="timeline-content">
                                <ul>
                                    <li>수원시 상수도사업소 실시간 수질정보시스템 구축</li>
                                    <li>한국기술사회 PMS 교육사업관리 시스템 유지보수</li>
                                    <li>교보문고 리트리딩 LMS 이러닝 시스템 구축 (PC웹, 모바일 웹)</li>
                                    <li>포스코 스마트러닝 LMS 이러닝 시스템 구축 (PC웹, 모바일 웹, 모바일 하이브리드 앱)</li>
                                    <li>기상청 국가기후자료관리 및 서비스체계 구축 3차년도 구축사업 (ProC 실시간 자료 QC 시스템 개발)</li>
                                    <li>대법원 판결서등 비실명화 검수시스템 구축</li>
                                    <li>서울시 평생교육 포털서비스 2차 고도화 (PC웹, 모바일 하이브리드 앱)</li>
                                    <li>한양대학교, 인하대학교 LMS 이러닝 시스템 구축 (PC웹, 모바일 웹, 모바일 하이브리드 앱)</li>
                                    <li>대구대학교 통합 온라인 학습지원 시스템 구축 (PC웹, 모바일 웹)</li>
                                    <li>서울시 평생교육 포털서비스 구축 (PC웹, 모바일 하이브리드 앱)</li>
                                    <li>동부증권 모바일 HTS 증권거래 시스템 구축 (모바일 앱, Android, iOS)</li>
                                    <li>영남대학교 LMS 이러닝 시스템 구축 (PC웹, 모바일 웹)</li>
                                    <li>KTH 파란 테마검색 서비스 개발</li>
                                    <li>외교통상부 지능형 영사민원시스템 고도화</li>
                                    <li>타임교육 티스터디 온라인 교육 포털 서비스(KMS, LMS, 모바일웹) 개발 (자체 프레임웍 납품)</li>
                                    <li>사단법인 한국공인중개사협회 공제보험시스템 고도화 (자체 프레임웍 납품)</li>
                                    <li>주식회사 티티엠소프트 회사설립</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section id="ai-solution">
        <div class="container">
            <div class="section-title reveal-up">Generative <span>AI Solution</span></div>
            <p class="section-desc reveal-up delay-1">TTMSoft만의 고도화된 생성형 AI 기술을 소개합니다.</p>
            
            <div class="ai-tabs-wrapper reveal-up delay-2" id="aiTabWrapper">
                <div class="ai-tabs-container" id="aiTabs">
                    <button class="ai-tab-btn active" data-target="ai-2">AI기반 규제정보 네비게이터 챗봇, RegNavigator AI(ver1.5)</button>
                    <button class="ai-tab-btn" data-target="ai-3">AI기반 영어 학습 튜터 플랫폼, 영어 AI 튜터(ver1.2)</button>
                    <button class="ai-tab-btn" data-target="ai-4">AI기반 이력서/자기소개서 자동 생성 도우미, 이력서도우미(ver1.6)</button>
                    <button class="ai-tab-btn" data-target="ai-1">유망기술 AI 솔루션</button>
                    <button class="ai-tab-btn" data-target="ai-5">AI기반 LMS학습관리시스템 문제 자동 생성기(ver2.1)</button>
                    <button class="ai-tab-btn" data-target="ai-6">AI 웹사이트 개인정보(PII) 스캔 솔루션(ver1.7)</button>
                    <button class="ai-tab-btn" data-target="ai-7">HWP 문서 AI 요약, 생성기 솔루션(ver1.2)</button>
                </div>
            </div>

            <div class="ai-content-wrapper">
                
                <div class="tab-content-area ai-detail" id="ai-1">
                    <div class="ai-spec-table">
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션명</div>
                            <div class="ai-spec-content">유망기술 발굴을 위한 생성형 AI 서비스</div>
                        </div>
                        <div class="ai-spec-row"><div class="ai-spec-label">AI 솔루션명 활용 분야</div><div class="ai-spec-content">④ 생성형 AI 솔루션 (텍스트, 이미지, 음악등의 새로운 미디어를 생성)</div></div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">데이터 보유·수집 현황</div>
                            <div class="ai-spec-content">
                                <p style="margin-bottom: 5px;">Custom Data 종류, 개수 및 수집방법</p>
                                <table class="ai-inner-table">
                                    <thead><tr><th style="width: 20%;">데이터 종류</th><th>데이터 개수</th><th>데이터 상세 내용</th></tr></thead>
                                    <tbody><tr><td>사업화 유망기술 텍스트 등 데이터</td><td>1,000권<br><span style="color: var(--text-sub);">(1억 토큰 이상)</span></td><td style="text-align: left;">각 연구기관 및 대학에서 제공하는 다양한 형식(hwp, pdf, jpeg)의 기술소개서 자료 및 과학기술일자리진흥원에서 제공하는 다양한 서적 데이터</td></tr></tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row"><div class="ai-spec-label">사용 프레임워크</div><div class="ai-spec-content">업화 유망기술발굴을 위한 기존 검색엔진 기술과 ChatGPT, sLLM 기술을 융합한 프레임워크 사용</div></div>
                        <div class="ai-spec-row"><div class="ai-spec-label">사용 아키텍쳐</div><div class="ai-spec-content">자체개발한 아키텍처 또는 사전학습모델(BERT, Transformer 기반의 pre-trained model)을 기반으로 파인튜닝(미세조정) 시킨 커스텀 아키텍쳐를 활용하여 적용함<br><span style="color: var(--accent-hover); margin-top: 10px; display: inline-block;">- 다양한 파인튜닝(PEFT) 기법들 활용하여 적용 (LoRA, Prefix Tuning, LLaMA-Adapter 등)</span></div></div>
                        <div class="ai-spec-row"><div class="ai-spec-label">학습데이터 결과서/ 테스트데이터 결과서</div>
                            <div class="ai-spec-content">
                                생성형 AI 기술을 위해 자연어 처리 알고리즘 적용 (TF-IDF / Word2Vec / BERT 을 활용한 유사도 평가) 하여 평가 진행함

                            </div>
                        </div>
                        <div class="ai-spec-row"><div class="ai-spec-label">AI 솔루션 세부 설명</div><div class="ai-spec-content">유망기술 발굴을 위한 생성형 AI 기술을 활용하여 사업화 유망 기술에 대한 다양한 유망 서비스 발굴 시나리오를 생성해 낼 수 있는 서비스</div></div>
                    </div>

                    <div class="ai-step-container">
                        <div class="ai-step-box">
                            <div class="ai-step-title">1. 사용 프레임워크</div>
                            <div class="framework-img-grid">
                                <div class="framework-img-card">
                                    <img src="/images/ai_01.png" alt="현재 유망기술 적용 프레임워크"> 
                                    <p>현재 유망기술 적용 프레임워크</p>
                                </div>
                                <div class="framework-img-card">
                                    <img src="/images/ai_02.png" alt="LLM을 적용할 수 있는 프레임워크 사용하여 기술 적용">
                                    <p>LLM을 적용할 수 있는 프레임워크 사용하여 기술 적용</p>
                                </div>
                                <div class="framework-img-card">
                                    <img src="/images/ai_03.png" alt="LLM/chatgpt를 이용하여 어플리케이션 개발">
                                    <p>LLM/chatgpt를 이용하여 어플리케이션 개발</p>
                                </div>
                            </div>
                        </div>

                        
                        <div class="ai-step-box"><div class="ai-step-title">2. 사용 아키텍처</div>
                            <div class="framework-img-grid">
                                <div class="framework-img-card">
                                    <img src="/images/ai_04.png" alt="현재의 유망기술 적용을 위한 아키텍처 + 트랜스포터기반의 GPT 및 LLM 기반을 융합 적용"> 
                                    <p>현재의 유망기술 적용을 위한 아키텍처 + 트랜스포터기반의 GPT 및 LLM 기반을 융합 적용</p>
                                </div>
                                <div class="framework-img-card">
                                    <img src="/images/ai_05.png" alt="모델에 대한 다양한 비교를 통한 최적의 아키텍처 구현">
                                    <p>모델에 대한 다양한 비교를 통한 최적의 아키텍처 구현</p>
                                </div>
                            </div>
                        </div>

                        <div class="ai-step-box">
                            <div class="ai-step-title">3. 학습데이터 및 테스트 결과</div>
                            <div class="framework-img-grid">
                                <div class="framework-img-card">
                                    <img src="/images/ai_06.png" alt="TF-IDF"> 
                                    <p>TF-IDF</p>
                                </div>
                                <div class="framework-img-card">
                                    <img src="/images/ai_07.png" alt="Word2Vec">
                                    <p>Word2Vec</p>
                                </div>
                                <div class="framework-img-card">
                                    <img src="/images/ai_08.png" alt="BERT">
                                    <p>BERT</p>
                                </div>
                                <div class="framework-img-card">
                                    <img src="/images/ai_09.png" alt="Top-K 벡터 정확도 검색에 의한 유사도 결과">
                                    <p>Top-K 벡터 정확도 검색에 의한 유사도 결과</p>
                                </div>
                            </div>
                        </div>

                        <div class="ai-step-box">
                            <div class="ai-step-title">4. 시스템 구축 예시</div>
                            <div class="framework-img-grid">
                                <div class="framework-img-card">
                                    <img src="/images/ai_10.png" alt="생성형 AI기반의 챗봇 및 유망기술 서비스 발굴을 위한 적용 예시"> 
                                    <p>생성형 AI기반의 챗봇 및 유망기술 서비스 발굴을 위한 적용 예시</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="tab-content-area ai-detail active" id="ai-2">
                    <div class="ai-spec-table">
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션명</div>
                            <div class="ai-spec-content">AI기반 규제정보 네비게이터 챗봇, RegNavigator AI(ver1.5)</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 종류</div>
                            <div class="ai-spec-content">웹 서비스 솔루션</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 인증서류</div>
                            <div class="ai-spec-content">자체 테스트결과서</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 활용 분야</div>
                            <div class="ai-spec-content">②자연어처리(번역, 음성인식, 감성분석, 챗봇, 문장요약, 검색 등) <br>
④생성형 AI(텍스트, 이미지, 음악등의 새로운 미디어를 생성) </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">데이터 보유·수집 현황</div>
                            <div class="ai-spec-content">
                                <p style="margin-bottom: 5px;">Custom Data 종류, 개수 및 수집방법</p>
                                <table class="ai-inner-table">
                                    <thead><tr><th style="width: 20%;">데이터 종류</th><th style="width: 20%;">데이터 개수</th><th>데이터 상세 내용</th></tr></thead>
                                    <tbody><tr><td>법률·규제 데이터</td><td>약 2만 Row</td>
                                        <td style="text-align: left;">법체처 국가법령정보센터에서 공개된 정보 활용(핀테크/바이오헬스/모빌리티 관련 31개 법령, 3619개 조문)</td></tr></tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row"><div class="ai-spec-label">사용 프레임워크</div><div class="ai-spec-content">Tensorflow, Milvus, vLLM, LangChain, HuggingFace Transformers</div></div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 아키텍쳐</div>
                            <div class="ai-spec-content">
                                Base Model : EXAONE (LG AI Research) / SOLAR (Upstage) — 한국어 특화 오픈소스 LLM<br>
                                임베딩 모델 : 한국어 법령 도메인 특화 Bi-Encoder (Dense Retrieval) <br>
                                Sparse 모델 : BM25 (키워드 기반 역색인) — Dense 벡터와 하이브리드 검색에 활용<br>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">학습데이터 결과서/<br>테스트데이터 결과서</div>
                            <div class="ai-spec-content">
                                
                                <h5 class="detail-sub-title" style="margin-top: 0;">가. 테스트 데이터셋에 대한 모델별 진실성 수치 측정</h5>
                                <div class="framework-img-grid" style="margin-top: 10px; margin-bottom: 30px;">
                                    <div class="framework-img-card" style="background: transparent; border: none; box-shadow: none; padding: 0; max-width: 500px;">
                                        <img src="/images/ch_01.png" alt="모델별 진실성 평가 그래프"> 
                                        <p style="font-weight: normal; color: var(--text-sub); font-size: 14px;">모델별 진실성(Truthfulness) 평가</p>
                                    </div>
                                </div>

                                <h5 class="detail-sub-title">나. 파인튜닝 성능 평가</h5>
                                
                                <p style="color: var(--text-main); font-weight: 700; margin-bottom: 10px;">- ROUGE 평가</p>
                                <table class="ai-inner-table">
                                    <thead>
                                        <tr>
                                            <th>모델</th>
                                            <th>참조값</th>
                                            <th>precision 평균</th>
                                            <th>recall 평균</th>
                                            <th>대비 percision값</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">기본모델</td>
                                            <td>gpt-4o-mini<br>요약문</td>
                                            <td>0.222781536</td>
                                            <td>0.113326008</td>
                                            <td>133%</td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">요약문_튜닝</td>
                                            <td>gpt-4o-mini<br>요약문</td>
                                            <td>0.217799482</td>
                                            <td>0.132272389</td>
                                            <td style="color: #ff5f56; font-weight: bold;">136%</td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">gpt-3.5-turbo</td>
                                            <td>gpt-4o-mini<br>요약문</td>
                                            <td>0.163333333</td>
                                            <td>0.107833713</td>
                                            <td>100%</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <p style="color: var(--text-main); font-weight: 700; margin-top: 25px; margin-bottom: 10px;">- BLEU 평가</p>
                                <table class="ai-inner-table">
                                    <thead>
                                        <tr>
                                            <th>모델</th>
                                            <th>참조값</th>
                                            <th>BLEU 평균</th>
                                            <th>gpt-3.5-turbo<br>대비 BLEU 값</th>
                                            <th>gpt-4o-mini<br>대비 BLEU 값</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">기본모델</td>
                                            <td>조 원문</td>
                                            <td>1.18924370</td>
                                            <td>51%</td>
                                            <td>44%</td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">QA_튜닝</td>
                                            <td>조 원문</td>
                                            <td>4.87256140</td>
                                            <td style="color: #ff5f56; font-weight: bold;">208%</td>
                                            <td style="color: #ff5f56; font-weight: bold;">181%</td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">요약_튜닝 +<br>QA_튜닝</td>
                                            <td>조 원문</td>
                                            <td>4.66321534</td>
                                            <td>119%</td>
                                            <td>173%</td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">gpt-3.5-turbo</td>
                                            <td>조 원문</td>
                                            <td>2.34751662</td>
                                            <td>100%</td>
                                            <td>87%</td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bold; color: var(--text-main);">gpt-4o-mini</td>
                                            <td>조 원문</td>
                                            <td>2.79287550</td>
                                            <td>115%</td>
                                            <td>100%</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <h5 class="detail-sub-title" style="margin-top: 30px;">다. 질문 증폭 강화학습 결과</h5>
                                <div class="detail-img-flex" style="margin-top: 10px;">
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_02.png" alt="Gradient Norm 결과">
                                        <p>질문 증폭 강화학습 결과: Gradient Norm</p>
                                    </div>
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_03.png" alt="Value Loss 결과">
                                        <p> 질문 증폭 강화학습 결과: Value Loss</p>
                                    </div>
                                </div>
                                <div class="detail-img-flex">
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_04.png" alt="Gradient Norm 결과">
                                        <p>이해 용이성 강화학습 결과: Gradient Norm</p>
                                    </div>
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_05.png" alt="Value Loss 결과">
                                        <p>이해 용이성 강화학습 결과: Value Loss</p>
                                    </div>
                                </div>

                                <h5 class="detail-sub-title" style="margin-top: 30px;">라. 서비스 개선지표</h5>
                                <div class="detail-img-flex" style="margin-top: 10px;">
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_06.png" alt="재질문율 변화 추이">
                                        <p>재질문율 변화 추이</p>
                                    </div>
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_07.png" alt="답변 만족도 변화 추이">
                                        <p>답변 만족도 변화 추이</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 세부 설명</div>
                            <div class="ai-spec-content">
                                <div class="ai-detail-list">
                                    <div class="ai-detail-item">
                                        <strong>가. 활용 분야</strong>
                                        <span>- 스타트업/중소기업, 기업 법무팀, 공공기관, 소상공인</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>나. 활용 방식</strong>
                                        <span>- 사용자는 웹/API 인터페이스를 통해 자연어로 규제 관련 질의를 입력하며, 시스템은 5개의 순서로 응답을 생성한다.</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>다. 기능</strong>
                                        <span>- 자연어 법령 질의 응답, 복합 조항 연계 검색, 조문 인용 근거 제시</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ai-step-container">
                        
                        <div class="ai-step-box">
                            <div class="ai-step-title">1. 아키텍처 레이어</div>
                            
                            <div class="architecture-grid">
                                <div class="arch-card">
                                    <div class="arch-title"><span>Layer 1</span> 문서 인덱싱 파이프라인</div>
                                    <ul class="arch-list">
                                        <li>법령 원문 데이터를 조문(Article) 단위로 파싱하여 계층 구조(법 → 시행령 → 시행규칙 → 별표) 보존</li>
                                        <li>각 청크에 대해 Dense 임베딩 벡터 + BM25 Sparse 벡터를 동시 생성하여 Milvus에 실시간 이중 인덱싱</li>
                                        <li>신규 법령 개정 시 차분(diff) 기반 증분 업데이트로 전체 재인덱싱 없이 운영 효율 확보</li>
                                    </ul>
                                </div>
                                
                                <div class="arch-card">
                                    <div class="arch-title"><span>Layer 2</span> 하이브리드 검색 엔진 (Milvus 기반)</div>
                                    <ul class="arch-list">
                                        <li>Dense Retrieval: 의미 유사도 기반 벡터 검색 (HNSW 인덱스, cosine similarity)</li>
                                        <li>Sparse Retrieval: BM25 키워드 매칭으로 법령 고유 명사 및 조문 번호 정밀 검색</li>
                                        <li>RRF(Reciprocal Rank Fusion)로 두 검색 결과를 융합하여 최종 후보 문서 선정</li>
                                        <li>Adaptive Retrieval Gate: 검색 문서 관련성 점수가 임계값 미만일 경우 주입 차단 (Self-RAG 아이디어 참고)</li>
                                    </ul>
                                </div>
                                
                                <div class="arch-card">
                                    <div class="arch-title"><span>Layer 3</span> LLM 파인튜닝 레이어 (Foundation Model + Custom)</div>
                                    <ul class="arch-list">
                                        <li>SVD 기반 중요도 분석으로 레이어별 rank 차등 배분 → 동일 파라미터 예산 대비 성능 최적화: AdaLoRA</li>
                                        <li>4-bit 양자화 + LoRA 결합으로 GPU 메모리 절감 (A100 80G 기준 단일 GPU 학습 가능): QLoRA</li>
                                        <li>학습 데이터 난이도 스코어링으로 전체 데이터의 40%만 선별하여 효율적 학습: IFD 커리큘럼</li>
                                        <li>Reference 모델 없는 단일 스테이지 선호도 최적화 → hallucination 억제: ORPO 정렬</li>
                                    </ul>
                                </div>
                                
                                <div class="arch-card">
                                    <div class="arch-title"><span>Layer 4</span> 추론 최적화 레이어 (vLLM)</div>
                                    <ul class="arch-list">
                                        <li>PagedAttention: KV 캐시를 페이지 단위로 동적 관리하여 메모리 단편화 제거</li>
                                        <li>Continuous Batching: 동시 다수 요청을 동적 배치로 묶어 GPU 활용률 극대화</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="framework-img-grid" style="margin-top: 30px;">
                                <div class="framework-img-card" style="max-width: 800px;"> 
                                    <img src="/images/ai_11.png" alt="데이터 가공 과정"> 
                                    <p>데이터 가공 과정</p>
                                </div>
                            </div>
                        </div>

                        <div class="ai-step-box" style="margin-top: 20px;">
                            <div class="ai-step-title">2. 세부 설명</div>
                            
                            <h5 class="detail-sub-title">가. 활용 분야</h5>
                            <table class="ai-inner-table" style="margin-top: 0; margin-bottom: 25px;">
                                <thead>
                                    <tr>
                                        <th style="width: 25%;">대상</th>
                                        <th>활용 내용</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td>기업 법무팀</td><td style="text-align: left;">규제 요건 자동 검색 및 컴플라이언스 체크리스트 생성</td></tr>
                                    <tr><td>스타트업/중소기업</td><td style="text-align: left;">사업 관련 인허가 요건, 과태료 기준 등 즉시 조회</td></tr>
                                    <tr><td>공공기관</td><td style="text-align: left;">법령 해석 지원 및 관련 하위 법령 자동 연계 탐색</td></tr>
                                    <tr><td>외국계 기업</td><td style="text-align: left;">한국 규제 환경 분석 및 다국어 요약 지원</td></tr>
                                </tbody>
                            </table>

                            <h5 class="detail-sub-title">나. 활용 방식</h5>
                            <table class="ai-inner-table" style="margin-top: 0; margin-bottom: 25px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;">단계</th>
                                        <th style="width: 45%;">처리 과정</th>
                                        <th style="width: 40%;">적용 기술</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td>① 질의 분석</td><td style="text-align: left;">사용자 질의 의도 파악 및 법령 키워드 추출</td><td style="text-align: left;">LLM 기반 Query Understanding</td></tr>
                                    <tr><td>② 문서 검색</td><td style="text-align: left;">Dense + Sparse 하이브리드 검색 실행</td><td style="text-align: left;">Milvus HNSW + BM25 → RRF 융합</td></tr>
                                    <tr><td>③ 관련성 판단</td><td style="text-align: left;">검색된 조문의 질의 관련성 자동 평가</td><td style="text-align: left;">Adaptive Retrieval Gate (임계값 기반 필터링)</td></tr>
                                    <tr><td>④ 답변 생성</td><td style="text-align: left;">파인튜닝된 LLM으로 법령 기반 답변 생성</td><td style="text-align: left;">vLLM + ORPO 정렬 모델 (hallucination 억제)</td></tr>
                                    <tr><td>⑤ 스트리밍 출력</td><td style="text-align: left;">실시간 토큰 단위 응답 전송</td><td style="text-align: left;">FastAPI SSE + vLLM Continuous Batching</td></tr>
                                </tbody>
                            </table>

                            <h5 class="detail-sub-title">다. 주요 기능</h5>
                            <ul class="detail-list">
                                <li>자연어 법령 질의응답: "음식점 위생 관리 위반 시 과태료 기준은?" 등 구어체 질의 처리</li>
                                <li>복합 조항 연계 검색: 법 → 시행령 → 시행규칙 → 별표까지 계층적 조문 자동 연결</li>
                                <li>조문 인용 근거 제시: 답변과 함께 참조 법령명, 조문 번호, 원문 링크 자동 제공</li>
                                <li>개정 법령 실시간 반영: 차분 기반 증분 인덱싱으로 법령 개정 즉시 검색 데이터 업데이트</li>
                                <li>다중 법령 비교: 유사한 규제 조항 간 차이점 비교 분석 응답 지원</li>
                            </ul>

                            <div class="detail-img-flex">
                                <div class="detail-img-box">
                                    <img src="/images/ai_12_1.png" alt="메인 화면: 질문 입력 가이드 반영">
                                    <p>메인 화면: 질문 입력 가이드 반영</p>
                                </div>
                                <div class="detail-img-box">
                                    <img src="/images/ai_12_2.png" alt="반응형 UI : PC(좌) 및 모바일(우)">
                                    <p>반응형 UI : PC(좌) 및 모바일(우)</p>
                                </div>
                            </div>
                        </div>

                        <div class="ai-step-box" style="margin-top: 20px;">
                            <div class="ai-step-title">3. 핵심 기술 혁신 포인트</div>
                            
                            <table class="ai-inner-table" style="margin-top: 10px;">
                                <thead>
                                    <tr>
                                        <th style="width: 25%;">기술</th>
                                        <th style="width: 50%;">문제 해결</th>
                                        <th style="width: 25%;">참고 논문/출처</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Milvus 하이브리드 검색</td>
                                        <td style="text-align: left;">단순 벡터 검색의 법령 고유명사 누락 → Dense+Sparse 융합으로 정밀도 향상</td>
                                        <td>RRF (Reciprocal Rank Fusion)</td>
                                    </tr>
                                    <tr>
                                        <td>AdaLoRA</td>
                                        <td style="text-align: left;">일괄 LoRA 적용의 비효율 → SVD 중요도 기반 레이어별 rank 차등 배분</td>
                                        <td>AdaLoRA, ICLR 2023</td>
                                    </tr>
                                    <tr>
                                        <td>IFD 커리큘럼 학습</td>
                                        <td style="text-align: left;">혼합 데이터 품질 편차 → 난이도 스코어 기반 40% 핵심 데이터 선별 학습</td>
                                        <td>NAACL 2024</td>
                                    </tr>
                                    <tr>
                                        <td>ORPO 정렬</td>
                                        <td style="text-align: left;">DPO의 Reference 모델 부담 → 단일 스테이지 선호도 최적화로 hallucination 억제</td>
                                        <td>ORPO, EMNLP 2024</td>
                                    </tr>
                                    <tr>
                                        <td>vLLM PagedAttention</td>
                                        <td style="text-align: left;">동시 접속 시 응답 30초 급증 → KV 캐시 페이지 관리로 87% 응답속도 개선</td>
                                        <td>vLLM, SOSP 2023</td>
                                    </tr>
                                    <tr>
                                        <td>RAGAS 피드백 루프</td>
                                        <td style="text-align: left;">파인튜닝 후 성능 측정의 주관성 → 자동 평가 기반 실패 케이스 재학습 루프 구축</td>
                                        <td>RAGAS, EACL 2024</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="ai-step-box" style="margin-top: 20px;">
                            <div class="ai-step-title">4. 확장성</div>
                            
                            <div class="step-desc-box">
                                <p>본 시스템은 규제·법령 도메인에 특화되어 개발되었으나, 핵심 아키텍처(하이브리드 RAG + 도메인 파인튜닝 + vLLM 서빙)는 대용량 전문 문서를 기반으로 한 질의응답이 필요한 모든 분야에 범용적으로 적용 가능합니다.</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="tab-content-area ai-detail" id="ai-3">
                    <div class="ai-spec-table">
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션명</div>
                            <div class="ai-spec-content">AI기반 영어 학습 튜터 플랫폼, 영어 AI 튜터(ver1.2)</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 종류</div>
                            <div class="ai-spec-content">기업 자체 웹 서비스 솔루션</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 인증서류</div>
                            <div class="ai-spec-content">기타</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 활용 분야</div>
                            <div class="ai-spec-content">②자연어처리(번역, 음성인식, 감성분석, 챗봇, 문장요약, 검색 등) <br>
④생성형 AI(텍스트, 이미지, 음악등의 새로운 미디어를 생성) </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">데이터 보유·수집 현황</div>
                            <div class="ai-spec-content">
                                <p style="margin-bottom: 5px;">Custom Data 종류, 개수 및 수집방법</p>
                                <table class="ai-inner-table">
                                    <thead><tr><th>데이터 종류</th><th>데이터 개수</th><th>데이터 상세 내용</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>영어 회화 문장 데이터</td>
                                            <td>약 50,000건</td>
                                            <td style="text-align: left;">공개 코퍼스 (OpenSubtitles, Tatoeba)</td>
                                        </tr>
                                        <tr>
                                            <td>발음 평가 음성 데이터</td>
                                            <td>약 10,000건</td>
                                            <td style="text-align: left;">Mozilla Common Voice, LibriSpeech</td>
                                        </tr>
                                        <tr>
                                            <td>어휘·문법 학습 콘텐츠</td>
                                            <td>약 20,000건</td>
                                            <td style="text-align: left;">CrewAI 자동 생성 + 전문가 검수</td>
                                        </tr>
                                        <tr>
                                            <td>사용자 대화 로그</td>
                                            <td>약 5,000건</td>
                                            <td style="text-align: left;">실 사용자 동의 기반 수집</td>
                                        </tr>
                                        <tr>
                                            <td>레벨 테스트 문항</td>
                                            <td>약 2,000건</td>
                                            <td style="text-align: left;">CrewAI 자동 생성 + 검증 에이전트</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 프레임워크</div>
                            <div class="ai-spec-content">LangChain, LangGraph, Azure Speech SDK</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 아키텍쳐</div>
                            <div class="ai-spec-content">
                                자체개발 아키텍처 또는 Foundation Model 기반으로 Custom Layer 추가시킨 커스텀 아키텍쳐 및 기본 동작원리 작성<br>
                                ※ Foundation Model 기반인 경우, 사용된 Foundation Model 명시함
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">학습데이터 결과서/ 테스트데이터 결과서</div>
                            <div class="ai-spec-content">
                                <table class="ai-inner-table">
                                    <thead><tr><th style="width: 28%;">평가 항목</th><th>성능 지표</th><th>학습 결과</th><th>테스트 결과</th><th>비고</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td style="text-align: left;">의도 분류 (Intent Classification)</td>
                                            <td>Accuracy / F1 Score</td>
                                            <td>Acc: 96.2% / F1: 0.957</td>
                                            <td>Acc: 93.8% / F1: 0.934</td>
                                            <td style="text-align: left;">4-class 분류</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">발음 평가 정확도</td>
                                            <td>Pearson r / MAE</td>
                                            <td>r=0.89 / MAE=4.2</td>
                                            <td>r=0.87 / MAE=4.8</td>
                                            <td style="text-align: left;">Azure Speech 비교 기준 +25%</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">학습 콘텐츠 생성 품질 (BLEU)</td>
                                            <td>BLEU Score</td>
                                            <td>-</td>
                                            <td>BLEU-4: 38.6</td>
                                            <td style="text-align: left;">CrewAI 생성 문항 기준</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">대화 응답 유창성 (Perplexity)</td>
                                            <td>PPL (Perplexity)</td>
                                            <td>-</td>
                                            <td>PPL: 18.4</td>
                                            <td style="text-align: left;">GPT-4 베이스 파운데이션 모델</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">번역 품질 (METEOR)</td>
                                            <td>METEOR Score</td>
                                            <td>-</td>
                                            <td>METEOR: 0.512</td>
                                            <td style="text-align: left;">한영 번역 에이전트</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 세부 설명</div>
                            <div class="ai-spec-content">
                                <div class="ai-detail-list">
                                    <div class="ai-detail-item">
                                        <strong>가. 활용 분야</strong>
                                        <span>- 회화 자동화 학습, 발음 교정, 어희/문법 학습, 레벨 테스트 및 맞춤 문항 제공</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>나. 활용 방식</strong>
                                        <span>- 실시간 AI 대화: 사용자 음성 입력 → Azure STT → LangGraph 의도 분류 → 전문 에이전트 처리 → GPT-4o 응답 생성 → Azure TTS → 음성 출력 전 과정이 1.5초 이내 처리됩니다.</span>
                                        <span>- 발음 평가: 사용자 음성을 Azure Pronunciation Assessment API로 분석하여 음소(phoneme) 단위 정확도 점수와 개선 포인트를 자동 제공합니다.</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>다. 기능</strong>
                                        <span>- 어휘 학습, 단어 설명, 예문 생성</span>
                                        <span>- 발음 평가 및 교정 피드백</span>
                                        <span>- 자유 프리토킹 대화</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ai-step-container">
                        <div class="ai-step-box">
                            <div class="ai-step-title">1. LangGraph 기반 멀티 에이전트 라우팅 아키텍처 상세</div>
                            <div class="step-desc-box">
                                <p>본 시스템의 핵심은 LangGraph로 설계된 동적 에이전트 라우팅 그래프입니다. 사용자의 자연어 입력은 먼저 Intent Classifier 노드에서 의미론적 분석을 거쳐 4가지 의도(어휘 학습, 발음 교정, 퀴즈/테스트, 자유 대화)로 분류됩니다. 분류된 의도에 따라 그래프의 조건부 엣지(Conditional Edge)가 활성화되어 가장 적합한 전문 에이전트 노드로 라우팅됩니다.
각 에이전트 노드는 LangChain의 ReAct(Reasoning + Acting) 패턴을 따르며, 필요한 경우 외부 도구(웹 검색, 사전 API, Azure Speech, 문제 DB)를 동적으로 호출합니다. 에이전트 간 상태(State)는 LangGraph의 StateGraph를 통해 공유되며, ConversationBufferMemory가 세션별 대화 히스토리를 유지하여 자연스러운 멀티턴 대화를 보장합니다.</p>
                            </div>
                            <div class="framework-img-grid" style="margin-top: 30px;">
                                <div class="framework-img-card" style="max-width: 800px;"> <img src="/images/ai_13.png" alt="챗봇 기능 flowChart"> 
                                    <p>챗봇 기능 flowChart</p>
                                </div>
                            </div>
                        </div> 
                        <div class="ai-step-box">
                            <div class="ai-step-title">2. 시스템 전체 데이터 흐름도</div>
                            
                            <div class="framework-img-grid">
                                <div class="framework-img-card" style="max-width: 800px;">
                                    <img src="/images/ai_14.png" alt="아키텍처">
                                </div>
                                
                                <p>아키텍처</p>
                            </div>
                        </div>
                    </div>


                </div>

                <div class="tab-content-area ai-detail" id="ai-4">
                    <div class="ai-spec-table">
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션명</div>
                            <div class="ai-spec-content">AI기반 이력서/자기소개서 자동 생성 도우미, 이력서도우미(ver1.6)</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 종류</div>
                            <div class="ai-spec-content">기업 자체 웹 서비스 솔루션</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 인증서류</div>
                            <div class="ai-spec-content">자체 테스트 결과서</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 활용 분야</div>
                            <div class="ai-spec-content">②자연어처리(번역, 음성인식, 감성분석, 챗봇, 문장요약, 검색 등) <br>
④생성형 AI(텍스트, 이미지, 음악등의 새로운 미디어를 생성) </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">데이터 보유·수집 현황</div>
                            <div class="ai-spec-content">
                                <p style="margin-bottom: 5px;">Custom Data 종류, 개수 및 수집방법</p>
                                <table class="ai-inner-table">
                                    <thead><tr><th>데이터 종류</th><th>데이터 개수</th><th>데이터 상세 내용</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>이력서 텍스트 데이터</td>
                                            <td>약 1,000건</td>
                                            <td style="text-align: left;">사용자 동의 기반 수집 + 공개 샘플</td>
                                        </tr>
                                        <tr>
                                            <td>채용공고 데이터</td>
                                            <td>약 20,000건</td>
                                            <td style="text-align: left;">실시간 크롤링 (잡코리아·사람인·워크넷)</td>
                                        </tr>
                                        <tr>
                                            <td>합격률 예측 라벨 데이터</td>
                                            <td>약 1,500건</td>
                                            <td style="text-align: left;">이력서-채용공고 매칭 결과 로그</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 프레임워크</div>
                            <div class="ai-spec-content">PyTorch 2.x, Hugging Face Transformers, OpenAI Whisper, MLflow, Apache Airflow</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 아키텍쳐</div>
                            <div class="ai-spec-content">
                                 - 이력서 생성 모듈<br>
                                - 매칭·합격률 예측 모듈<br>
                                - MLOps 파이프라인 (자체 설계)
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">학습데이터 결과서/ 테스트데이터 결과서</div>
                            <div class="ai-spec-content">
                                
                                <h5 class="detail-sub-title" style="margin-top: 0;">가. 이력서·채용공고 매칭 모델 학습 커브</h5>
                                <p style="color: var(--text-main); font-size: 14px; margin-bottom: 15px;">- klue/roberta-base 파인튜닝 / Epoch</p>
                                
                                <div class="detail-img-flex" style="margin-bottom: 30px;">
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_08.png" alt="Train / Validation Loss">
                                        <p>Train / Validation Loss</p>
                                    </div>
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_09.png" alt="Validation F1 Score · Accuracy">
                                        <p>Validation F1 Score · Accuracy</p>
                                    </div>
                                </div>

                                <h5 class="detail-sub-title">나. 테스트 데이터 결과서</h5>
                                <table class="ai-inner-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 22%;">평가 항목</th>
                                            <th>성능 지표</th>
                                            <th>학습 결과</th>
                                            <th>테스트 결과</th>
                                            <th>비고</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="text-align: left;">이력서-채용공고 매칭</td>
                                            <td>Accuracy<br>F1</td>
                                            <td>Acc 95.1%<br>F1 0.943</td>
                                            <td>Acc 91.4%<br>F1 0.908</td>
                                            <td style="text-align: left;">klue/roberta-base 파인튜닝</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">합격률 예측 (회귀)</td>
                                            <td>AUC<br>Loss</td>
                                            <td>AUC 0.891<br>Loss 0.18</td>
                                            <td>AUC 0.874<br>Loss 0.22</td>
                                            <td style="text-align: left;">BCE Loss 기준</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">음성 인식 (STT)</td>
                                            <td>WER<br>(Word Error Rate)</td>
                                            <td>-</td>
                                            <td>WER 8.3%</td>
                                            <td style="text-align: left;">Whisper medium-ko</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">이력서 생성 품질</td>
                                            <td>BLEU<br>METEOR</td>
                                            <td>-</td>
                                            <td>BLEU 42.1<br>METEOR 0.541</td>
                                            <td style="text-align: left;">GPT-4 생성 vs 전문가 작성</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">자기소개서 생성 품질</td>
                                            <td>BLEU / PPL</td>
                                            <td>-</td>
                                            <td>BLEU 38.7 / PPL 14.2</td>
                                            <td style="text-align: left;">GPT-4 기반, 한국어 기준</td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <p style="color: var(--text-sub); font-size: 13px; margin-top: 15px; word-break: keep-all;">
                                    ※ 평가 환경: Python 3.10 / GPU NVIDIA A100 40GB / 테스트셋 20% 분할(Random Seed 42) / MLflow 실험 추적
                                </p>

                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 세부 설명</div>
                            <div class="ai-spec-content">
                                <div class="ai-detail-list">
                                    <div class="ai-detail-item">
                                        <strong>가. 활용 분야</strong>
                                        <span>- 50대 이상 장년층 구직자를 위한 AI 이력서 생성·취업 매칭 플랫폼. 디지털 취약 계층의 구직 활동 지원 및 사회적 가치 실현을 목적으로 합니다.</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>나. 활용 방식</strong>
                                        <span>- 음성 이력서 입력: 마이크 녹음 → STT → 구조화 텍스트 변환</span>
                                        <span>- AI 이력서 자동 생성: 경력 정보 입력 → GPT-4 프롬프트 → 완성 이력서</span>
                                        <span>- 채용공고 매칭: 이력서 ↔ 채용공고 임베딩 유사도 계산</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>다. 기능</strong>
                                        <span>- 음성 이력서 입력, AI 이력서 자동 생성, 채용공고 매칭, 합력률 예측</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ai-step-container">
                        <div class="ai-step-box">
                            <div class="ai-step-title">1. 시스템 전체 아키텍처 및 데이터 흐름</div>
                            <div class="step-desc-box">
                                <p>본 플랫폼은 사용자 인터페이스(React 프론트엔드)부터 AI 추론 서버(FastAPI), 데이터 파이프라인(Airflow), MLOps 관리(MLflow), 모니터링(Prometheus·Grafana)까지 엔드-투-엔드 MLOps 생태계를 구성합니다. 전체 데이터 흐름은 다음과 같습니다.</p>
                            </div>
                            <div class="framework-img-grid" style="margin-top: 30px;">
                                <div class="framework-img-card" style="max-width: 800px;"> <img src="/images/ai_15.png" alt="서비스 플로우"> 
                                    <p>서비스 플로우</p>
                                </div>
                            </div>
                            <h5 class="detail-sub-title">가. 사용자 입력 → 이력서 생성 플로우</h5>
                            <ul class="detail-list">
                                <li>사용자가 React 앱에서 마이크 버튼을 누르면 음성 스트림이 FastAPI WebSocket 엔드포인트로 전달됩니다.</li>
                                <li>FastAPI 서버 내 faster-whisper 모듈이 실시간 STT를 수행하여 한국어 텍스트로 변환합니다. (평균 변환 지연: 1.4초 이내) 변환된 텍스트는 경력 정보 파싱 모듈을 통해 직무·기간·기술스택·성과의 4가지 카테고리로 구조화됩니다.</li>
                                <li>구조화된 정보는 GPT-4 API에 Few-shot Prompt 형식으로 전달되어 표준 이력서 포맷(개인정보·경력·학력·자격증·자기소개서)으로 완성됩니다.</li>
                                <li>생성된 이력서는 PostgreSQL의 mlops.resumes 테이블에 저장되고, 사용자 화면에 Markdown 렌더링으로 즉시 표시됩니다.</li>
                            </ul>
                            <h5 class="detail-sub-title">나. 채용공고 크롤링 → 매칭 플로우</h5>
                            <ul class="detail-list">
                                <li>Apache Airflow의 CrawlingDAG가 매일 오전 2시 잡코리아·사람인·워크넷의 채용공고를 크롤링하여 mlops.job_postings에 저장합니다.</li>
                                <li>전처리 DAG가 채용공고 텍스트를 정규화(HTML 제거, 특수문자 처리, 중복 제거)하여 BERT 입력 형식으로 변환합니다.</li>
                                <li>사용자가 '매칭 시작'을 요청하면 이력서와 상위 1,000개 채용공고를 klue/roberta-base 모델로 임베딩 후 Cosine Similarity를 계산합니다.</li>
                                <li>상위 20개 채용공고에 대해 Classification Head가 합격 확률(%)을 산출하여 사용자에게 추천 목록으로 제공합니다.</li>
                                <li>매칭 결과는 mlops.prediction_logs 테이블에 기록되어 향후 모델 재학습의 피드백 데이터로 활용됩니다.</li>
                            </ul>
                            <div class="framework-img-grid" style="margin-top: 30px;">
                                <div class="framework-img-card" style="max-width: 800px;"> <img src="/images/ai_16.png" alt="시스템 아키텍처"> 
                                    <p>시스템 아키텍처</p>
                                </div>
                            </div>
                        </div> 
                        <div class="ai-step-box">
                            <div class="ai-step-title">2. 핵심 AI 모델 상세 — 이력서-채용공고 매칭 모델</div>
                            <div class="step-desc-box">
                                <p>매칭 모델은 Hugging Face의 klue/roberta-base(한국어 사전학습 RoBERTa)를 Foundation Model로 채택하여, 이력서와 채용공고 간 의미론적 유사도를 학습한 커스텀 아키텍처입니다.</p>
                            </div>

                            <h5 class="detail-sub-title">가. 모델 구조 상세</h5>
                            <ul class="detail-list">
                                <li>Encoder Layer: klue/roberta-base (12 Transformer Layers, Hidden Size 768, 12 Attention Heads, 파라미터 약 110M)</li>
                                <li>Pooling Layer: [CLS] 토큰 벡터 추출 → 768차원 문장 임베딩 생성</li>
                                <li>Similarity Layer: 이력서 임베딩(e_r)과 채용공고 임베딩(e_j)의 Cosine Similarity 계산 → 스칼라 유사도 점수</li>
                                <li>Classification Head: Linear(768→256) → GELU → Dropout(0.1) → Linear(256→1) → Sigmoid → 합격 확률 출력</li>
                            </ul>
                            <h5 class="detail-sub-title">나. 학습전략</h5>
                            <ul class="detail-list">
                                <li>학습 데이터: 이력서-채용공고 매칭 쌍 30,000건 (Positive 15,000 / Hard Negative Mining으로 구성된 Negative 15,000)</li>
                                <li>Loss Function: Binary Cross-Entropy Loss + Contrastive Loss의 가중합 (α=0.7, β=0.3)으로 분류 정확도와 임베딩 품질을 동시에 최적화</li>
                                <li>Optimizer: AdamW (lr=2e-5, weight_decay=0.01), Linear Warmup(10%) + Cosine Annealing 스케줄러</li>
                                <li>학습 환경: GPU NVIDIA A100 40GB, Batch Size 64, Epoch 5, Mixed Precision(FP16), 총 학습 시간 약 4시간</li>
                                <li>정규화: Label Smoothing(ε=0.1), Gradient Clipping(max_norm=1.0)로 과적합 방지</li>
                            </ul>
                            <div class="framework-img-grid">
                                <div class="framework-img-card">
                                    <img src="/images/ai_17.png" alt="데이터 자동화 파이프라인">
                                    <p>데이터 자동화 파이프라인</p>
                                </div>
                            </div>
                            <h5 class="detail-sub-title">다. 평과 결과</h5>
                            <ul class="detail-list">
                                <li>Validation: Accuracy 95.1%, F1 Score 0.943, AUC-ROC 0.891</li>
                                <li>Test Set (20% 홀드아웃): Accuracy 91.4%, F1 Score 0.908, AUC-ROC 0.874</li>
                                <li>기준 모델(TF-IDF + 코사인 유사도) 대비 F1 +18.3%p, AUC +12.1%p 개선</li>
                            </ul>
                        </div>
                    </div>


                </div>


                <div class="tab-content-area ai-detail" id="ai-5">
                    <div class="ai-spec-table">
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션명</div>
                            <div class="ai-spec-content">AI기반 LMS학습관리시스템 문제 자동 생성기(ver2.1)</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 종류</div>
                            <div class="ai-spec-content">기업 자체 웹 서비스 솔루션</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 인증서류</div>
                            <div class="ai-spec-content">자체 테스트 결과서</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 활용 분야</div>
                            <div class="ai-spec-content">②자연어처리(번역, 음성인식, 감성분석, 챗봇, 문장요약, 검색 등) <br>
④생성형 AI(텍스트, 이미지, 음악등의 새로운 미디어를 생성) </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">데이터 보유·수집 현황</div>
                            <div class="ai-spec-content">
                                <p style="margin-bottom: 5px;">Custom Data 종류, 개수 및 수집방법</p>
                                <table class="ai-inner-table">
                                    <thead><tr><th>데이터 종류</th><th>데이터 개수</th><th>데이터 상세 내용</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>강의 스크립트 텍스트</td>
                                            <td>약 80,000건</td>
                                            <td style="text-align: left;">OCR 변환 + 자막 파일(SRT/VTT) + 공개 MOOCs</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 프레임워크</div>
                            <div class="ai-spec-content">LangChain, CrewAI, Whisper, PyTorch 2.x, Hugging Face Transformers</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 아키텍쳐</div>
                            <div class="ai-spec-content">
                                 - 아키텍처 분류: Foundation Model 기반 + 다중 에이전트(Multi-Agent) 커스텀 오케스트레이션 아키텍처<br>
                                - 사용 Foundation Model: OpenAI GPT-4o (문제 생성·번역), klue/roberta-base (문항 품질 검증 분류기)
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">학습데이터 결과서/ 테스트데이터 결과서</div>
                            <div class="ai-spec-content">
                                <table class="ai-inner-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 22%;">평가 항목</th>
                                            <th>성능 지표</th>
                                            <th>학습 결과</th>
                                            <th>테스트 결과</th>
                                            <th>비고</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="text-align: left;">문항 생성 품질 (객관식)</td>
                                            <td>BLEU-4 METEOR</td>
                                            <td>-</td>
                                            <td>BLEU 44.2 METEOR 0.558</td>
                                            <td style="text-align: left;">전문가 작성 기준 비교</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">문항 생성 품질 (서술·단답)</td>
                                            <td>BLEU-4 ROUGE-L</td>
                                            <td>-</td>
                                            <td>BLEU 38.7 ROUGE-L 0.612</td>
                                            <td style="text-align: left;">GPT-4o 생성 기준</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">문항 품질 검증 (이진 분류)</td>
                                            <td>Accuracy F1</td>
                                            <td>Acc 96.1% F1 0.951</td>
                                            <td>Acc 93.4% F1 0.921</td>
                                            <td style="text-align: left;">klue/roberta 파인튜닝</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">오답 보기 품질 (객관식)</td>
                                            <td>AUC-ROC</td>
                                            <td>0.907</td>
                                            <td>0.884</td>
                                            <td style="text-align: left;">Distractor 적합성 분류</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">STT 음성 인식 정확도</td>
                                            <td>WER (Word Error Rate)</td>
                                            <td>-</td>
                                            <td>WER 7.8%</td>
                                            <td style="text-align: left;">한국어 강의 기준</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 세부 설명</div>
                            <div class="ai-spec-content">
                                <div class="ai-detail-list">
                                    <div class="ai-detail-item">
                                        <strong>가. 활용 분야</strong>
                                        <span>- 대학·기업·평생학습 LMS에서 교사·강사의 문제 출제 부담을 줄이고, 동영상·PDF·DOC 강의자료를 AI가 자동 분석하여 학습 검증용 문항을 즉시 생성합니다.</span>
                                        <span>- 현재 SaaS 로 전환 개발 진행중(공정율 90%, 4월 출시 예정)</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>나. 활용 방식</strong>
                                        <span>- 동영상 강의: MP4 업로드 → STT → 개념 청크 추출</span>
                                        <span>- PDF·DOC 자료 : 구조 추출 → 섹션별 핵심 개념 파악</span>
                                        <span>- 핵심 개념 기반 문항 자동 생성</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>다. 기능</strong>
                                        <span>- 동영상 강의 분석</span>
                                        <span>- PDF·DOC 자료 분석</span>
                                        <span>- 단답형, 서술형, 객관식 문제 자동 생성</span>
                                        <span>- 난이도 조절 및 문제 개별 수정</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="ai-step-container">
                        <div class="ai-step-box">
                            <div class="ai-step-title">1. 시스템 전체 데이터 흐름 및 처리 파이프라인</div>
                            <div class="step-desc-box">
                                <p>본 AI 솔루션은 강의자료(동영상·PDF·DOC) 업로드부터 최종 문항 저장까지 5단계 자동화 파이프라인으로 구성됩니다. 각 단계는 FastAPI 비동기 서버와 Celery 작업 큐로 처리되며, 대용량 파일도 논블로킹 방식으로 처리합니다.</p>
                            </div>
                            <div class="framework-img-grid" style="margin-top: 30px;">
                                <div class="framework-img-card" style="max-width: 800px;"> <img src="/images/ai_18.png" alt="시스템 요약"> 
                                    <p>서비스 플로우</p>
                                </div>
                            </div>
                            <div class="flow-container">
    
                                <div class="flow-box">
                                    <div class="flow-header">
                                        <span class="flow-step-badge">STEP 1</span>
                                        <h4 class="flow-title">강의자료 수신 및 포맷 분기</h4>
                                    </div>
                                    <ul class="flow-content-list">
                                        <li>교사·강사가 LMS 대시보드에서 동영상(MP4·MOV·AVI), PDF, DOC/DOCX 파일을 업로드합니다.</li>
                                        <li>FastAPI 서버가 파일 포맷을 자동 감지하여 동영상은 STT 처리 큐, 문서는 OCR·파서 큐로 분기합니다.</li>
                                        <li>Celery Worker가 비동기로 처리하여 대용량 파일(1시간 강의 동영상 등) 업로드 시에도 UI가 블로킹되지 않습니다.</li>
                                    </ul>
                                </div>

                                <div class="flow-box">
                                    <div class="flow-header">
                                        <span class="flow-step-badge">STEP 2</span>
                                        <h4 class="flow-title">강의자료 전처리 및 구조화</h4>
                                    </div>
                                    <ul class="flow-content-list">
                                        <li>동영상 처리: faster-whisper(medium 모델, int8 양자화)로 STT 수행 → 화자 분리 → 문장 단위 타임스탬프 부착 → 주제별 청크(평균 500토큰) 자동 분할</li>
                                        <li>PDF 처리: PyMuPDF로 텍스트·표·이미지 캡션 추출 → 섹션 헤더(폰트 크기 기반) 인식 → 계층적 구조(챕터→섹션→단락)로 파싱</li>
                                        <li>DOC/DOCX 처리: python-docx로 스타일 정보(Heading1/2/3) 기반 구조 추출 → 표 데이터 별도 파싱 → 내부 이미지 ALT 텍스트 활용</li>
                                        <li>전처리 완료 후 핵심 개념 추출: TF-IDF + KeyBERT(klue/roberta-base 기반)로 청크별 핵심 키워드 및 개념어 5~10개 자동 추출</li>
                                    </ul>
                                </div>

                                
                                
                                <div class="flow-box">
                                    <div class="flow-header">
                                        <span class="flow-step-badge">STEP 3</span>
                                        <h4 class="flow-title">다중 에이전트 문제 생성 파이프라인 (CrewAI Sequential Crew)</h4>
                                    </div>
                                    <ul class="flow-content-list">
                                        <li>구조화된 강의 콘텐츠가 CrewAI Crew 객체에 전달되어 3개 에이전트가 순차적으로 작업을 수행합니다.</li>
                                        <li>에이전트 간 데이터는 CrewAI의 Task Output 체인으로 전달되며, 각 에이전트는 독립적인 LLM 호출과 Tool 사용 권한을 가집니다.</li>
                                    </ul>
                                </div>

                                
                                
                                <div class="flow-box">
                                    <div class="flow-header">
                                        <span class="flow-step-badge">STEP 4</span>
                                        <h4 class="flow-title">검증 및 품질 필터링</h4>
                                    </div>
                                    <ul class="flow-content-list">
                                        <li>검증자 에이전트의 1차 자동 검증 후, 통과 문항은 DB에 저장되고 실패 문항은 피드백과 함께 출제자 에이전트로 재전달됩니다.</li>
                                        <li>재생성 루프는 최대 3회까지 허용되며, 3회 후에도 검증 실패 시 '수동 검토 필요' 상태로 교사 대기 목록에 등록됩니다.</li>
                                    </ul>
                                </div>

                                
                                
                                <div class="flow-box">
                                    <div class="flow-header">
                                        <span class="flow-step-badge">STEP 5</span>
                                        <h4 class="flow-title">교사 검토 및 최종 배포</h4>
                                    </div>
                                    <ul class="flow-content-list">
                                        <li>E자동 생성된 문항이 LMS 문제 은행에 '검토 대기' 상태로 등록되며, 교사는 미리보기·수정·승인·거부 작업을 UI에서 수행합니다.</li>
                                        <li>E승인된 문항은 자동으로 시험·퀴즈에 배정 가능한 상태가 되며, 교사 수정 데이터는 다음 모델 재학습의 피드백 데이터로 활용됩니다.</li>
                                    </ul>
                                </div>

                            </div>
                        </div> 
                        <div class="ai-step-box">
                            <div class="ai-step-title">2. LMS 연동 구조 및 실제 활용 시나리오</div>
                            <div class="step-desc-box">
                                <p>매칭 모델은 Hugging Face의 klue/roberta-base(한국어 사전학습 RoBERTa)를 Foundation Model로 채택하여, 이력서와 채용공고 간 의미론적 유사도를 학습한 커스텀 아키텍처입니다.</p>
                            </div>

                            <h5 class="detail-sub-title">가. LMS 연동 방식</h5>
                            <ul class="detail-list">
                                <li>REST API 기반 연동: FastAPI 서버가 LMS와 RESTful API로 통신하며, 기존 Moodle·Canvas·자체 LMS에 플러그인 또는 API 모듈 형태로 통합</li>
                                <li>문제 은행 자동 연동: 생성·검증된 문항이 LMS 문제 은행(Question Bank)에 자동으로 카테고리·태그와 함께 등록</li>
                                <li>IMS QTI 표준 지원: 생성된 문항을 IMS QTI 2.1 XML 형식으로 내보내기하여 다른 LMS·시험 시스템과의 호환성 보장</li>
                            </ul>
                            <h5 class="detail-sub-title">나. 실제 활용 시나리오</h5>
                            <div class="framework-img-grid">
                                <div class="framework-img-card">
                                    <img src="/images/ai_19.png" alt="시스템 아키텍처 오버뷰">
                                    <p>시스템 아키텍처 오버뷰</p>
                                </div>
                            </div>
                            <ul class="detail-list" style="margin-top: 20px;">
                                <li>시나리오 1 – 강의 직후 즉시 평가: 교수가 강의 영상 업로드 후 AI 문항 생성 요청 → 10분 이내 20문항 퀴즈 자동 생성 → 학생에게 즉시 배포</li>
                                <li>시나리오 2 – 기말고사 문제 은행 구축: 한 학기 강의자료(PDF 15건) 일괄 업로드 → 150문항 자동 생성 → 교사 검토 후 난이도별 분류 → 시험 자동 출제</li>
                                <li>시나리오 3 – 기업 교육 e-Learning: HR 담당자가 사내 교육 동영상 업로드 → 직급별 난이도 설정 → 수료 테스트 자동 생성 → 결과 LMS에 자동 기록</li>
                                <li>시나리오 4 – 개인화 복습 문제: 학생의 오답 이력 분석 → 해당 개념 강의 청크 재추출 → 맞춤형 보완 문항 생성 → 개인 학습 경로에 자동 배정</li>
                            </ul>
                            <div class="framework-img-grid">
                                <div class="framework-img-card">
                                    <img src="/images/ai_23.png" alt="AI 시험문제 등록 화면">
                                    <p>AI 시험문제 등록 화면</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="tab-content-area ai-detail" id="ai-6">
                    <div class="ai-spec-table">
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션명</div>
                            <div class="ai-spec-content">AI 웹사이트 개인정보(PII) 스캔 솔루션(ver1.7)</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 종류</div>
                            <div class="ai-spec-content">기업 자체 웹 서비스 솔루션</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 인증서류</div>
                            <div class="ai-spec-content">자체 테스트 결과서</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 활용 분야</div>
                            <div class="ai-spec-content">②자연어처리(번역, 음성인식, 감성분석, 챗봇, 문장요약, 검색 등) <br>
④생성형 AI(텍스트, 이미지, 음악등의 새로운 미디어를 생성) </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">데이터 보유·수집 현황</div>
                            <div class="ai-spec-content">
                                <p style="margin-bottom: 5px;">Custom Data 종류, 개수 및 수집방법</p>
                                <table class="ai-inner-table">
                                    <thead><tr><th>데이터 종류</th><th>데이터 개수</th><th>데이터 상세 내용</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>PLL 패턴 정규표현식 규칙셋</td>
                                            <td>약 200 종</td>
                                            <td style="text-align: left;">NIST·GDPR·개인정보보호법 기준 자체 정의</td>
                                        </tr>
                                        <tr>
                                            <td>합성 PLL 테스트 데이터</td>
                                            <td>약 5,000 건</td>
                                            <td style="text-align: left;">Faker 라이브러리 기반 자동 생성 (실제 개인정보 미사용)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 프레임워크</div>
                            <div class="ai-spec-content">OpenCV, Playwright, Pytorch 2.x, PaddleOCR</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 아키텍쳐</div>
                            <div class="ai-spec-content">
                                 - 아키텍처 분류: Foundation Model 기반 + 자체 PII 탐지 파이프라인 커스텀 아키텍처 (하이브리드 구조) 사용<br>
                                - Foundation Model: YOLOv8 (시각적 PII 영역 탐지), klue/roberta-base (텍스트 NER), GPT-4o Vision (맥락 검증 보조)
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">학습데이터 결과서/ 테스트데이터 결과서</div>
                            <div class="ai-spec-content">
                                <h5 class="detail-sub-title" style="margin-top: 0;">가. PII — 시각적 탐지 모델 학습 커브</h5>
                                <p style="color: var(--text-main); font-size: 14px; margin-bottom: 15px;">- YOLOv8 파인튜닝 / Epoch 50</p>
                                
                                <div class="detail-img-flex" style="margin-bottom: 30px;">
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_10.png" alt="Train / Validation Loss">
                                        <p>Train / Validation Loss</p>
                                    </div>
                                    <div class="detail-img-box" style="background: transparent; border: none; padding: 0;">
                                        <img src="/images/ch_11.png" alt="Validation F1 Score · Accuracy">
                                        <p>Validation F1 Score · Accuracy</p>
                                    </div>
                                </div>

                                <h5 class="detail-sub-title">나. 테스트 데이터 결과서</h5>
                                <table class="ai-inner-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 22%;">평가 항목</th>
                                            <th>성능 지표</th>
                                            <th>학습 결과</th>
                                            <th>테스트 결과</th>
                                            <th>비고</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="text-align: left;">PII 영역 시각 탐지 (YOLOv8)</td>
                                            <td>mAP@0.5</td>
                                            <td>mAP 0.913</td>
                                            <td>mAP 0.882</td>
                                            <td style="text-align: left;">바운딩박스 기준</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">PII 유형 분류 NER (roberta)</td>
                                            <td>F1 Score</td>
                                            <td>F1 0.948</td>
                                            <td>F1 0.924</td>
                                            <td style="text-align: left;">7개 PII 유형 분류</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">전체 PII 탐지 정밀도/재현율</td>
                                            <td>Precision / Recall</td>
                                            <td>-</td>
                                            <td>P 0.931 / R 0.907</td>
                                            <td style="text-align: left;">실제 웹 페이지 테스트셋</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">이진 PII 포함 여부 분류</td>
                                            <td>AUC-ROC</td>
                                            <td>0.971</td>
                                            <td>0.958</td>
                                            <td style="text-align: left;">페이지 단위 판정</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">OCR 텍스트 인식 정확도</td>
                                            <td>Accuracy</td>
                                            <td>-</td>
                                            <td>97.3%</td>
                                            <td style="text-align: left;">PaddleOCR 기준</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p style="color: var(--text-sub); font-size: 13px; margin-top: 15px; word-break: keep-all;">
                                    ※ 평가 환경: Python 3.11 / GPU NVIDIA A100 / 테스트셋 20% 홀드아웃(합성 PII 데이터 기준) / 실제 개인정보 미사용
                                </p>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 세부 설명</div>
                            <div class="ai-spec-content">
                                <div class="ai-detail-list">
                                    <div class="ai-detail-item">
                                        <strong>가. 활용 분야</strong>
                                        <span>- 보안 감사(Security Audit): 외부 웹사이트 대상 개인정보 노출 취약점 점검 보고서 자동 생성</span>
                                        <span>- 개인정보보호법·GDPR 준수 여부 모니터링: 실시간 또는 주기적 자동 스캔으로 규정 위반 사항 조기 탐지</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>나. 활용 방식</strong>
                                        <span>- 기업 개인정보 컴플라이언스 점검: 자사 웹사이트·내부 포털에 노출된 개인정보를 정기 자동 스캔</span>
                                        <span>- 공공기관 개인정보 영향평가 보조: 웹 서비스의 PII 노출 위험 구간 사전 식별</span>
                                        <span>- 보안 감사(Security Audit): 외부 웹사이트 대상 개인정보 노출 취약점 점검 보고서 자동 생성</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>다. 기능</strong>
                                        <span>- 시각적 PII 영역 탐지</span>
                                        <span>- 빨간 박스 하이라이트</span>
                                        <span>- 대시보드 상세 리포트</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="ai-step-container">
                        <div class="ai-step-box">
                            <div class="ai-step-title">1. 시스템 전체 데이터 흐름 및 처리 파이프라인</div>
                            <div class="step-desc-box">
                                <p>PII 개인정보 스캔 솔루션은 웹사이트 URL 입력부터 대시보드 리포트 생성까지 6단계 자동화 파이프라인으로 동작합니다. 시각적 AI 분석과 텍스트 NLP 분석을 병렬로 수행하여 탐지 정확도를 극대화하는 하이브리드 구조입니다.</p>
                            </div>
                            <h5 class="detail-sub-title">① 웹 페이지 자동 캡처 및 텍스트 추출</h5>
                            <ul class="detail-list">
                                <li>Playwright가 Headless Chromium으로 대상 URL에 접속하여 전체 페이지(Full-page) 스크린샷을 PNG 형식으로 자동 촬영합니다.</li>
                                <li>스크롤이 필요한 긴 페이지는 뷰포트 단위로 분할 캡처 후 이미지를 세로로 합성합니다.</li>
                                <li>DOM 파싱으로 HTML 텍스트를 병행 추출하여 시각 분석과 텍스트 분석 두 경로로 동시 전달합니다.</li>
                                <li>JavaScript 렌더링이 필요한 동적 페이지(React·Vue·Angular)도 완전 렌더링 후 캡처합니다.</li>
                            </ul>
                            <h5 class="detail-sub-title">② 이미지 전처리 및 텍스트 블록 탐지 (YOLOv8)</h5>
                            <ul class="detail-list">
                                <li>OpenCV로 스크린샷을 1280px 기준으로 정규화하고, 대비 향상(CLAHE)으로 텍스트 가독성을 높입니다.</li>
                                <li>YOLOv8 파인튜닝 모델이 스크린샷 전체를 입력받아 텍스트가 포함된 UI 컴포넌트 영역(입력 폼·테이블·카드·레이블)을 바운딩박스로 탐지합니다.</li>
                                <li>탐지된 영역은 PII 포함 가능성 신뢰도(Confidence Score)와 함께 다음 단계로 전달됩니다.</li>
                            </ul>
                            <h5 class="detail-sub-title">③ OCR 텍스트 추출 (PaddleOCR)</h5>
                            <ul class="detail-list">
                                <li>YOLOv8이 탐지한 각 바운딩박스 영역을 크롭(Crop)하여 PaddleOCR에 개별 입력합니다.</li>
                                <li>PaddleOCR의 한국어·영어 이중 언어 모드로 텍스트를 추출합니다 (OCR 정확도 97.3%).</li>
                                <li>DOM 추출 텍스트와 OCR 텍스트를 위치 좌표 기반으로 매핑하여 상호 보완합니다.</li>
                            </ul>
                            <h5 class="detail-sub-title">④ PII 유형 분류 (NER + 정규표현식)</h5>
                            <ul class="detail-list">
                                <li>klue/roberta-base 기반 NER 모델이 추출 텍스트에서 개인정보 엔티티를 인식하고 유형을 분류합니다 (F1 0.924).</li>
                                <li>NER 결과를 200종 정규표현식 패턴(주민번호 형식, 전화번호 형식, 이메일 형식 등)으로 교차 검증합니다.</li>
                                <li>신뢰도가 낮은 경계 케이스(Confidence 0.6~0.8 구간)는 GPT-4o Vision에 맥락 기반 최종 판단을 요청합니다.</li>
                            </ul>
                            <h5 class="detail-sub-title">⑤ 시각화 – 빨간 박스 오버레이</h5>
                            <ul class="detail-list">
                                <li>확인된 PII의 바운딩박스 좌표에 OpenCV의 rectangle() 함수로 두께 3px 빨간(RGB: 220, 38, 38) 직사각형 박스를 원본 스크린샷 위에 오버레이합니다.</li>
                                <li>PII 유형 레이블(예: '이메일', '전화번호')을 박스 상단에 작은 텍스트로 함께 표시합니다.</li>
                                <li>동일 페이지 내 다수 PII 발견 시 유형별 색상 구분(이름: 빨강, 이메일: 주황, 전화: 분홍 등) 옵션을 제공합니다.</li>
                            </ul>
                            <h5 class="detail-sub-title">⑥ 대시보드 리포트 생성</h5>
                            <ul class="detail-list">
                                <li>발견된 PII 전체 목록을 유형·심각도·위치(X, Y 좌표 및 URL)·탐지 신뢰도로 구조화하여 웹 대시보드에 렌더링합니다.</li>
                                <li>페이지별 PII 발견 건수 통계, 유형별 분포 차트, 심각도 분류(High/Medium/Low) 요약을 인터랙티브 차트로 제공합니다.</li>
                                <li>하이라이트된 스크린샷을 대시보드 내 뷰어에서 바로 확인할 수 있으며, 클릭 시 해당 PII 상세 정보를 팝업으로 표시합니다.</li>
                            </ul>
                            <div class="framework-img-grid" style="margin-top: 30px;">
                                <div class="framework-img-card" style="max-width: 800px;"> <img src="/images/ai_20.png" alt="웹사이트 개인정보 스캔 화면"> 
                                    <p>웹사이트 개인정보 스캔 화면</p>
                                </div>
                            </div>
                        </div> 
                    </div>

                </div>

                <div class="tab-content-area ai-detail" id="ai-7">
                    <div class="ai-spec-table">
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션명</div>
                            <div class="ai-spec-content">HWP 문서 AI 요약, 생성기 솔루션(ver1.2)</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 종류</div>
                            <div class="ai-spec-content">기업 자체 웹 서비스 솔루션</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 인증서류</div>
                            <div class="ai-spec-content">자체 테스트 결과서</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 활용 분야</div>
                            <div class="ai-spec-content">②자연어처리(번역, 음성인식, 감성분석, 챗봇, 문장요약, 검색 등) <br>
④생성형 AI(텍스트, 이미지, 음악등의 새로운 미디어를 생성) </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">데이터 보유·수집 현황</div>
                            <div class="ai-spec-content">
                                <p style="margin-bottom: 5px;">Custom Data 종류, 개수 및 수집방법</p>
                                <table class="ai-inner-table">
                                    <thead><tr><th>데이터 종류</th><th>데이터 개수</th><th>데이터 상세 내용</th></tr></thead>
                                    <tbody>
                                        <tr>
                                            <td>OCR 학습 이미지 데이터</td>
                                            <td>약 2,500건</td>
                                            <td style="text-align: left;">AI Hub 한국어 OCR 데이터셋 (HWP 내 이미지 텍스트 인식용)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 프레임워크</div>
                            <div class="ai-spec-content">Hugging Face Transformers, pyhwp / hwp5, Pillow / pdf2image</div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">사용 아키텍쳐</div>
                            <div class="ai-spec-content">
                                 - 아키텍처 분류: Foundation Model 기반 커스텀 파이프라인 아키텍처<br>
                                - 사용 Foundation Model: OpenAI GPT-4o (문서 분석·요약·구조화), KoBART (한국어 추출 요약 보조)
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">학습데이터 결과서/ 테스트데이터 결과서</div>
                            <div class="ai-spec-content">
                                <table class="ai-inner-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 22%;">평가 항목</th>
                                            <th>성능 지표</th>
                                            <th>학습 결과</th>
                                            <th>테스트 결과</th>
                                            <th>비고</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="text-align: left;">문서 요약 품질</td>
                                            <td>ROUGE-L</td>
                                            <td>0.641</td>
                                            <td>0.618</td>
                                            <td style="text-align: left;">공고문 도메인 기준</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">문서 요약 유창성</td>
                                            <td>BLEU-4</td>
                                            <td>-</td>
                                            <td>41.3</td>
                                            <td style="text-align: left;">GPT-4o 생성 기준</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">요약 의미 정확도</td>
                                            <td>METEOR</td>
                                            <td>-</td>
                                            <td>0.527</td>
                                            <td style="text-align: left;">전문가 작성 요약</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">텍스트 자연스러움</td>
                                            <td>PPL (Perplexity)</td>
                                            <td>-</td>
                                            <td>15.4</td>
                                            <td style="text-align: left;">한국어 기준</td>
                                        </tr>
                                        <tr>
                                            <td style="text-align: left;">HWP 텍스트 추출 정확도</td>
                                            <td>Accuracy</td>
                                            <td>-</td>
                                            <td>98.10%</td>
                                            <td style="text-align: left;">pyhwp 파싱 기준</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="ai-spec-row">
                            <div class="ai-spec-label">AI 솔루션 세부 설명</div>
                            <div class="ai-spec-content">
                                <div class="ai-detail-list">
                                    <div class="ai-detail-item">
                                        <strong>가. 활용 분야</strong>
                                        <span>- 공공기관·지자체의 HWP 공문서·공고문을 웹 게시판에 빠르게 등록</span>
                                        <span>- 기업 내부 HWP 보고서·기획안의 핵심 내용 자동 추출 및 요약</span>
                                        <span>- 문서 관리 시스템(DMS)에 HWP 문서 메타데이터 자동 입력 지원</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>나. 활용 방식</strong>
                                        <span>- HWP 파일 업로드 → AI 자동 분석 → HTML 요약 결과물 + 이미지 미리보기 즉시 생성</span>
                                        <span>- 생성된 HTML 결과물을 공고 게시판·LMS·CMS에 원클릭으로 바로 등록 가능</span>
                                        <span>- API 방식으로 기존 문서 관리 시스템에 연동하여 자동화 워크플로 구성 지원</span>
                                    </div>
                                    <div class="ai-detail-item">
                                        <strong>다. 기능</strong>
                                        <span>- HWP 파일 파싱</span>
                                        <span>- 텍스트 정제</span>
                                        <span>- 이미지 렌더링</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="ai-step-container">
                        <div class="ai-step-box">
                            <div class="ai-step-title">1. 시스템 전체 데이터 흐름 및 처리 파이프라인</div>
                            <h5 class="detail-sub-title">① HWP 파서</h5>
                            <ul class="detail-list">
                                <li>HWP 바이너리 파싱 → 텍스트·표·이미지·메타데이터 분리</li>
                            </ul>
                            <h5 class="detail-sub-title">② 텍스트 정제기 / 이미지 렌더러</h5>
                            <ul class="detail-list">
                                <li>제어문자 제거, 줄바꿈 정규화, 문단·섹션 구조 JSON 변환</li>
                                <li>HWP 내 표·그림·도식 영역을 Pillow로 PNG 렌더링</li>
                            </ul>
                            <h5 class="detail-sub-title">③ GPT-4o AI 분석</h5>
                            <ul class="detail-list">
                                <li>텍스트+이미지 멀티모달 통합 분석, 제목·요약·항목·일정 구조화</li>
                            </ul>
                            <h5 class="detail-sub-title">④ HTML 생성기</h5>
                            <ul class="detail-list">
                                <li>요약 JSON을 시맨틱 HTML5로 변환 (제목·본문·표·이미지 포함)</li>
                                <li>요약 내용을 미리보기용 카드 이미지로 렌더링</li>
                            </ul>
                            <div class="framework-img-grid" style="margin-top: 30px;">
                                <div class="framework-img-card" style="max-width: 800px;"> <img src="/images/ai_21.jpg" alt="인포그래픽"> 
                                    <p>인포그래픽</p>
                                </div>
                            </div>
                        </div> 
                        <div class="ai-step-box">
                            <div class="ai-step-title">2. 실제 활용 시나리오</div>
                            <div class="framework-img-grid">
                                <div class="framework-img-card" style="max-width: 800px;"> <img src="/images/ai_22.png" alt="AI 요약 화면"> 
                                    <p>AI 요약 화면</p>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>

            </div>
        </div>

        <button id="floatingTabBtn" class="floating-tab-btn">↑ 다른 탭 보기</button>
    </section>

    <section id="business">
        <div class="container">
            <div class="section-title reveal-up">Our <span>Business & Portfolio</span></div>
            <p class="section-desc reveal-up delay-1">TTMSoft의 다양한 실적과 사업 영역을 확인해 보세요.</p>
            
            <div class="scroll-tabs-wrapper reveal-up delay-2" id="bizTabWrapper">
                <div class="scroll-tabs-container" id="bizTabs">
                    <button class="biz-tab-btn active" data-target="biz-12">웹 포털 및 모바일 어플 서비스 구축</button>
                    <button class="biz-tab-btn" data-target="biz-4">기상관측 종합관리시스템 구축 및 고도화, 유지보수</button>
                    <button class="biz-tab-btn" data-target="biz-6">기후예측-분석 통합시스템 구축 및 고도화, 유지보수</button>
                    <button class="biz-tab-btn" data-target="biz-1">e-learning LMS 구축</button>
                    <button class="biz-tab-btn" data-target="biz-2">검색엔진 서비스 구축</button>
                    <button class="biz-tab-btn" data-target="biz-3">MSTR OLAP 통계 구축</button>
                    <button class="biz-tab-btn" data-target="biz-5">WMS 물류시스템</button>
                    <button class="biz-tab-btn" data-target="biz-7">역량통합관리시스템</button>
                    <button class="biz-tab-btn" data-target="biz-8">공공데이터 매칭 지원</button>
                    <button class="biz-tab-btn" data-target="biz-9">연구개발 마켓플레이스</button>
                    <button class="biz-tab-btn" data-target="biz-10">M&S 마켓플레이스</button>
                    <button class="biz-tab-btn" data-target="biz-11">개방형 기술가치평가</button>
                </div>
            </div>

            <div class="biz-detail-wrapper reveal-scale">

                <div class="biz-detail active" id="biz-12">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">웹 포털 및 모바일 어플 서비스 구축 </h3>
                                <p class="biz-desc">한양사이버대학교 SSO 및 웹/모바일 포털시스템 재구축, 한국공인중개사협회 부동산 시스템, 서울시 평생학습포털 등 공공 및 교육 기관의 대규모 웹/모바일 서비스를 성공적으로 구축한 사용자 중심 솔루션입니다.</p>
                                <div class="ai-tags"><span>SSO 통합인증</span><span>포틀릿 UI</span><span>하이브리드 앱</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc12_p.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc12_s.png');"></div>
                                </div>
                                
                                <div class="frame-mobile reveal-right">
                                    <div class="mobile-screen" style="background-image: url('/images/isc12_m.png');"></div>
                                </div>
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 특장점</h4>
                            <ul class="slider_detail_list">
                                <li>학습로그인 유예 안내 기능, 전자결재, 업무결재, 학사신청, 법인카드미정산, 결근, 지각, 상담, Q&A, 공지사항, 학사/행정, 학습진도관리, 실시간세미나, 연구비정산, 수강신청, 수강정정, 멘토링, 강사료, 급여, 업적평가 등의 기능을 포틀릿으로 구현</li>
                                <li>간편번호 인증, 생체 인증, 카카오 인증, 공동 인증서 인증, 아이디/패스워드 인증 SSO 기능 제공</li>
                                <li>기상관측종합관리시스템 개선을 통한 고품질의 기상 관측자료 확보로 위험기상 대응 강화, 예보정확도 향상에 적극적 기여</li> 
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-4">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">기상관측 종합관리시스템 구축 및 고도화, 유지보수</h3>
                                <ul class="desc-p">
                                    <li>기상청은 국가기상관측을 총괄하고 있음. 이와 관련하여 기상장비를 효율적으로 관리·운영하기 위해 「기상관측종합관리시스템」 구축<br>
                                        - 기상관측(장비 도입, 운영, 장애관리, 유지관리, 폐기 등)의 종합관리 수행</li>
                                        <li>기상관측장비에 대한 상시적 장애감시, 신속한 장애조치 및 실시간 자료율 향상 등을 위한 시스템 개선 및 24시간 365일 무중단 서비스를 위한 안정적, 전문적인 유지보수와 개선 필요</li>
                                        <li>기상관측장비의 효율적 관리를 위한 기능 개선, 관측자료 수집·처리 및 장애감시시스템 고도화, 사용자 모니터링 업무 개선 등 추가 개발</li>
                                        <li>기상관측종합관리시스템 개선을 통한 고품질의 기상 관측자료 확보로 위험기상 대응 강화, 예보정확도 향상에 적극적 기여</li>
                                        <li>지상·고층·해양의 모든 장비에 대한 관측자료 수집관리, 장애관리, 품질관리, 이력관리 등을 강화하여 정확하고 신뢰성 있는 기상정보 제공</li>

                                </ul>
                                <div class="ai-tags"><span>공동활용(OSS)</span><span>실시간 모니터링</span><span>공공SI</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc11.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc11_s.png');"></div>
                                </div>
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 구축 사례</h4>
                            <ul class="slider_detail_list">
                                <li>2026년 기상관측 종합관리시스템 운영 및 유지관리 </li>
                                <li>2025년 기상관측 종합관리시스템 기능 개선</li>
                                <li>2025년 기상관측 종합관리시스템 운영 및 유지관리</li> 
                                <li>2024년 기상관측 종합관리시스템 기능 개선</li>
                                <li>2024년 기상관측 종합관리시스템 운영 및 유지관리</li> 
                                <li>2023년 기상관측 종합관리시스템 기능 개선</li>
                                <li>2023년 기상관측 종합관리시스템 운영 및 유지관리</li> 
                                <li>2022년 기상관측 종합관리시스템 기능 개선</li>
                                <li>2022년 기상관측 종합관리시스템 운영 및 유지관리</li> 
                                <li>2021년 기상관측 종합관리시스템 기능 개선</li>
                                <li>2021년 기상관측 종합관리시스템 운영 및 유지관리</li> 
                                <li>2020년 기상관측 종합관리시스템 기능 개선</li>
                                <li>2020년 기상관측 종합관리시스템 운영 및 유지관리</li> 
                                <li>2019년 기상관측 종합관리시스템 기능 개선</li>
                                <li>2019년 기상관측 종합관리시스템 운영 및 유지관리</li> 
                                <li>2018년 기상청 날씨제보시스템 개선 </li>
                                <li>2018년 기상관측 종합관리시스템 고도화</li>
                                <li>2016년 기상관측 종합관리시스템 구축</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="biz-detail" id="biz-6">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">기후예측-분석 통합시스템 구축 및 고도화, 유지보수</h3>
                                <ul class="desc-p">
                                    <li>기후예측-분석 통합시스템의 유지관리 업무 수행<br>
                                        - HW, SW등에 대한 운영점검 및 운영환경 유지 관리<br>
                                        - 정기점검 및 긴급점검을 통한 사전 장애 예방 및 긴급복구<br>
                                        - 시스템 중요 데이터의 주기적 백업 및 장애시 복원<br>
                                        - 기 개발된 기후예측-분석 통합시스템 콘텐츠의 유지관리</li>
                                    <li>웹 접근성·호환성 점검 및 조치, 보안취약점 제거(개선)</li>
                                    <li>해양기후 감시 및 기후예측모델 예측성 분석</li>
                                    <li>기후예측 통보문 개발 및 개선</li>
                                    <li>사용자 편의 제공을 위한 기후감시예측정보 모바일웹 개발 구축</li>
                                    <li>기후예측 통계분석을 위한 서비스 개발</li>
                                    <li>기존 콘텐츠, 통보문·정보지 기능개선 및 개발</li>
                                    <li>연구용역 사업 등에서 산출 결과물, 가이던스 탑재 개발 등 현업화</li>
                                </ul>
                                <div class="ai-tags"><span>기후 예측 데이터</span><span>의사결정 지원</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc05.png');"></div>
                                </div>

                                <div class="frame-mini reveal-right">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc05_s.png');"></div>
                                </div>
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 구축 사례</h4>
                            <ul class="slider_detail_list">
                                <li>2026년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2025년 기후예측-분석 통합시스템 개선(II)</li>
                                <li>2025년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2024년 기후예측-분석 통합시스템 개선(Ⅱ)</li>
                                <li>2024년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2023년 기후예측-분석 통합시스템 개선(I)</li>
                                <li>2023년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2022년 이상기후전망 정확도향상기술 시스템 개선</li>
                                <li>2022년 기후예측-분석 통합시스템 고도화 </li>
                                <li>2022년 기상관측 종합관리시스템 운영 및 유지관리</li>
                                <li>2021년 기후예측-분석 통합시스템 구축 </li>
                                <li>2020년 지역장기예보 생산시스템 기능강화(Ⅱ)</li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="biz-detail" id="biz-1">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">e-learning LMS 솔루션 구축사업</h3>
                                <p class="biz-desc">신규 디자인 리뉴얼 및 기능 개선을 통한 고도화 작업. 글로벌 & 소셜러닝 플랫폼으로의 서비스 확장 및 추가기능 개발을 수행합니다.</p>
                                <div class="ai-tags"><span>온라인 학습관리</span><span>LMS/LCMS</span><span>이러닝</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc01_p.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc01_s.png');"></div>
                                </div>
                                
                                <div class="frame-mobile reveal-right">
                                    <div class="mobile-screen" style="background-image: url('/images/isc01_m.png');"></div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="biz-cases">
                            <h4>✔ 서비스 구축 사례</h4>
                            <ul class="slider_detail_list">
                                <li>2026년 서울시평생교육포털 유지보수</li>
                                <li>2025년 서울시평생교육포털 유지보수</li>
                                <li>2024년 서울시평생교육포털 고도화 사업</li>
                                <li>2024년 서울시평생교육포털 유지보수</li>
                                <li>2023년 서울시평생교육포털 고도화 사업</li>
                                <li>2023년 서울시평생교육포털 유지보수</li>
                                <li>2022년 서울시평생교육포털 유지보수</li>
                                <li>2021년 서울시평생교육포털 유지보수</li>
                                <li>2021년 서울시평생교육포털 고도화 사업</li>
                                <li>2020년 서울시평생교육포털 유지보수</li>
                                <li>2019년 서울시평생교육포털 고도화 사업</li>
                                <li>2019년 서울시평생교육포털 유지보수</li>
                                <li>2018년 서울시평생교육포털 유지보수</li>
                                <li>2017년 서울시평생교육포털 기능개선 사업</li>
                                <li>2015년 서울시평생교육포털 고도화 사업</li>
                                <li>2011년 서울시평생교육포털 구축 사업</li>
                                <li>한양대학교, 인하대학교, 영남대학교, 대구대학교 등</li>
                                <li>교보문고, 포스코, 코레일 구축</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-2">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">검색엔진 서비스 구축 사업</h3>
                                <p class="biz-desc">융통성과 정확성을 갖춘 검색 솔루션 XTEN 및 대용량 처리를 위한 Elasticsearch 기반의 통합 검색 서비스를 구축합니다.</p>
                                <div class="ai-tags"><span>Elasticsearch</span><span>대용량 포털 검색</span><span>웹 로봇 수집기</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc02.png');"></div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="biz-cases">
                            <h4>✔ 서비스 구축 사례</h4>
                            <ul class="slider_detail_list">
                                <li>파란 검색/광고 서비스 구축 및 운영</li>
                                <li>파란 뉴스/지식바다 서비스 구축 및 운영</li>
                                <li>리니지 1,2 지식검색 및 통합검색 서비스 구축</li>
                                <li>플레이포럼 지식검색 서비스 구축</li>
                                <li>야후 지식검색 서비스 구축</li>
                                <li>벅스뮤직 통합검색 서비스 구축</li>
                                <li>KBS 국제뉴스아카이브 검색 서비스 구축</li>
                                <li>MBC 통합자산 검색 서비스 구축</li>
                                <li>네이버 지역검색 서비스 개발</li>
                                <li>네이버 검색광고 운영시스템 개발</li>
                                <li>원자력병원 통합검색 서비스 구축</li>
                                <li>국가기록원 기록물 통합검색서비스 개발</li>
                                <li>윕스 특허자료 통합검색 서비스 개발</li>
                                <li>위즈도메인 통합검색서비스 개발</li>
                                <li>행자부 자료관 사업 통합검색시스템 구축</li>
                                <li>웹 로봇 수집기 솔루션 개발</li>
                                <li>대검찰청 압수수색 PC수사물 검색솔루션 개발</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-3">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">MSTR OLAP 통계 솔루션 구축</h3>
                                <p class="biz-desc">연계, 점검, 장애, 품질관리 시스템 등에 대한 수집 데이터를 일자 단위로 데이터베이스화하고 분석 통계를 시각화하는 솔루션입니다.</p>
                                <div class="ai-tags"><span>MicroStrategy</span><span>OLAP</span><span>빅데이터 통계</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc03.png');"></div>
                                </div>
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 구축 사례</h4>
                            <ul class="slider_detail_list">
                                <li>2016년 건강보험공단 빅데이터 구축 사업 구축</li>
                                <li>건강보험심사평가원 2016년 정보화 사업 구축</li>
                                <li>2016년 기상관측 통합모니터링 시스템 구축 사업</li>
                            </ul>
                        </div>
                    </div>
                </div>

                
                <div class="biz-detail" id="biz-5">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">WMS 물류시스템 구축</h3>
                                <p class="biz-desc">물류/운영 기준정보, 입고, 출고, 반품, 유통, 재고, 예정관리를 통합 지원하는 커스텀 프레임워크 기반의 물류 솔루션입니다.</p>
                                <div class="ai-tags"><span>Loaf 자체 프레임워크</span><span>클라우드 환경</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc04.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc04_s.png');"></div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 특장점</h4>
                            <ul class="slider_detail_list">
                                <li>Loaf 자체 프레임웍 개발, 적용</li>
                                <li>클라우드 환경</li>
                                <li>Java, Jsp, Kendo Grid, MSSQL DB</li>
                                <li>물류/운영 기준정보, 입고관리, 출고관리, 반품관리, 유통관리, 재고관리, 예정관리 등의 요소로 구성</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-6">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">기후예측-분석 통합시스템 구축 및 고도화, 유지보수</h3>
                                <ul class="desc-p">
                                    <li>기후예측-분석 통합시스템의 유지관리 업무 수행<br>
                                        - HW, SW등에 대한 운영점검 및 운영환경 유지 관리<br>
                                        - 정기점검 및 긴급점검을 통한 사전 장애 예방 및 긴급복구<br>
                                        - 시스템 중요 데이터의 주기적 백업 및 장애시 복원<br>
                                        - 기 개발된 기후예측-분석 통합시스템 콘텐츠의 유지관리</li>
                                    <li>웹 접근성·호환성 점검 및 조치, 보안취약점 제거(개선)</li>
                                    <li>해양기후 감시 및 기후예측모델 예측성 분석</li>
                                    <li>기후예측 통보문 개발 및 개선</li>
                                    <li>사용자 편의 제공을 위한 기후감시예측정보 모바일웹 개발 구축</li>
                                    <li>기후예측 통계분석을 위한 서비스 개발</li>
                                    <li>기존 콘텐츠, 통보문·정보지 기능개선 및 개발</li>
                                    <li>연구용역 사업 등에서 산출 결과물, 가이던스 탑재 개발 등 현업화</li>
                                </ul>
                                <div class="ai-tags"><span>기후 예측 데이터</span><span>의사결정 지원</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="browser-header"><span class="browser-dot" style="background:#ff5f56;"></span><span class="browser-dot" style="background:#ffbd2e;"></span><span class="browser-dot" style="background:#27c93f;"></span></div>
                                <div class="browser-body" style="background-image: url('/images/isc05.png');"></div>
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 구축 사례</h4>
                            <ul class="slider_detail_list">
                                <li>2026년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2025년 기후예측-분석 통합시스템 개선(II)</li>
                                <li>2025년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2024년 기후예측-분석 통합시스템 개선(Ⅱ)</li>
                                <li>2024년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2023년 기후예측-분석 통합시스템 개선(I)</li>
                                <li>2023년 기후예측-분석 통합시스템 유지관리</li>
                                <li>2022년 이상기후전망 정확도향상기술 시스템 개선</li>
                                <li>2022년 기후예측-분석 통합시스템 고도화 </li>
                                <li>2022년 기상관측 종합관리시스템 운영 및 유지관리</li>
                                <li>2021년 기후예측-분석 통합시스템 구축 </li>
                                <li>2020년 지역장기예보 생산시스템 기능강화(Ⅱ)</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-7">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">역량통합관리시스템</h3>
                                <p class="biz-desc">비교과 운영의 효율화, 객관적인 역량 진단, 체계적인 진로 설계 기능을 통합 제공하는 대학 전용 맞춤형 솔루션입니다.</p>
                                <div class="ai-tags"><span>Spring Boot</span><span>Java</span><span>Oracle</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc06.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc06_s.png');"></div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 특장점</h4>
                            <ul class="slider_detail_list">
                                <li>spring boot, oracle, Java, JavaScript, HTML</li>
                                <li>각 대학에서 학생들을 대상으로 비교과프로그램, 역량진단, 진로탐색 서비스를 운영•관리 할 수 있도록 다양한 관리 기능을 제공하는 시스템 구축</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-8">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">공공데이터 기업 매칭 지원사업</h3>
                                <p class="biz-desc">미래기술마당의 정보시스템을 기반으로 데이터 거버넌스를 구축하고, 방대한 빅데이터 처리를 통해 사업화 유망기술 발굴 서비스를 자동화합니다.</p>
                                <div class="ai-tags"><span>TensorFlow</span><span>BERT</span><span>BatchApp</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc07.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc07_s.png');"></div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 서비스 특장점</h4>
                            <ul class="slider_detail_list">
                                <li>Spring Batch, Spring Jpa 기술을 이용한 BatchApp 개발</li>
                                <li>TensorFlow와 BERT, TF-IDF 알고리즘을 응용한 문서간 유사도 측정</li>
                                <li>MS AI form recognizer기술을 이용한 데이터 가공</li>
                                <li>spring boot, postgres, jenkins, colab, MS AI form recognizer</li>
                                <li>Java, Python</li>
                                <li>미래기술마당의 정보시스템을 기반으로 사업화 유망기술발굴을 위한 데이터 거버넌스를 구축하고 이를 토대로 방대한 빅데이터 처리를 통해, 자동화된 신개념 사업화 유망기술 발굴 서비스 개발</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-9">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">연구개발 마켓플레이스 (우리가치R&D)</h3>
                                <p class="biz-desc">입찰을 통해 연구개발 서비스를 구매 및 판매할 수 있는 통합 플랫폼입니다. 기업 매칭 알고리즘과 블록체인 기반 계약 지원을 제공합니다.</p>
                                <div class="ai-tags"><span>Elastic Stack</span><span>블록체인(Corda)</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc08.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc08_s.png');"></div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 사용 기술</h4>
                            <ul class="slider_detail_list">
                                <li>WEB 서버 : Apache httpd , Nginx</li>
                                <li>WAS : Apache Tomcat</li>
                                <li>DBMS : Postgresql</li>
                                <li>서버 어플리케이션 : Spring Boot(Java), JPA, Mybatis</li>
                                <li>빌드/패키지 관리 : Maven, Gradle</li>
                                <li>Cache : Redis &nbsp;&nbsp;&nbsp; 블록체인 : Corda</li>
                                <li>검색엔진 : Elastic Stack (Elastic Search, Logstash, Kibana)</li>
                                <li>UI : React, Jquery, Echart</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-10">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">M&S 마켓플레이스 (이룸R&D)</h3>
                                <p class="biz-desc">소규모 연구개발 서비스를 손쉽게 구매하고 판매할 수 있는 스토어 형태의 서비스 플랫폼입니다.</p>
                                <div class="ai-tags"><span>Spring Boot</span><span>Redis</span><span>Corda</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc09.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc09_s.png');"></div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 사용 기술</h4>
                            <ul class="slider_detail_list">
                                <li>WEB 서버 : Apache httpd , Nginx</li>
                                <li>WAS : Apache Tomcat</li>
                                <li>DBMS : Postgresql</li>
                                <li>서버 어플리케이션 : Spring Boot(Java), JPA, Mybatis</li>
                                <li>빌드/패키지 관리 : Maven, Gradle</li>
                                <li>Cache : Redis &nbsp;&nbsp;&nbsp; 블록체인 : Corda</li>
                                <li>검색엔진 : Elastic Stack(Elastic Search, Logstash, Kibana)</li>
                                <li>UI : React, Jquery, Echart</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="biz-detail" id="biz-11">
                    <div class="biz-content-layout">
                        <div class="biz-top-row">
                            <div class="biz-text-col">
                                <h3 class="biz-title">개방형 기술가치평가 서비스</h3>
                                <p class="biz-desc">기업이 보유한 기술을 등록하고, 다양한 분야의 기술 전문가를 통해 시장성 및 기술성을 투명하게 평가받을 수 있는 개방형 서비스입니다.</p>
                                <div class="ai-tags"><span>기술 매칭</span><span>전문가 네트워킹</span><span>Postgresql</span></div>
                            </div>
                            <div class="biz-image-col">
                                <div class="frame-main">
                                    <div class="browser-header">
                                        <span class="browser-dot" style="background:#ff5f56;"></span>
                                        <span class="browser-dot" style="background:#ffbd2e;"></span>
                                        <span class="browser-dot" style="background:#27c93f;"></span>
                                    </div>
                                    <div class="browser-body" style="background-image: url('/images/isc10.png');"></div>
                                </div>

                                <div class="frame-mini reveal-left">
                                    <div class="mini-header">
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                        <span class="mini-dot"></span>
                                    </div>
                                    <div class="mini-body" style="background-image: url('/images/isc10_s.png');"></div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="biz-cases">
                            <h4>✔ 사용 기술</h4>
                            <ul class="slider_detail_list">
                                <li>WEB 서버 : Apache httpd , Nginx</li>
                                <li>WAS : Apache Tomcat</li>
                                <li>DBMS : Postgresql</li>
                                <li>서버 어플리케이션 : Spring Boot(Java), JPA, Mybatis</li>
                                <li>빌드/패키지 관리 : Maven, Gradle</li>
                                <li>Cache : Redis</li>
                                <li>검색엔진 : Elastic Stack 기반의 빠른 데이터 검색</li>
                                <li>블록체인 : Corda</li>
                                <li>UI : React, Jquery, Echart</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <section id="location">
        <div class="container">
            <h2 class="section-title reveal-up">Location</h2>
            <p class="section-desc reveal-up delay-1">TTMSoft로 오시는 길을 안내해 드립니다.</p>

            <div class="location-box reveal-up delay-2">
                <div class="map-area">
                    <div id="daumRoughmapContainer1771825024178" class="root_daum_roughmap root_daum_roughmap_landing"
                        style="width: 100%;"></div>
                </div>

                <div class="location-info-area">
                    <h3 class="location-title">Contact & Location</h3>
                    <ul class="location-details">
                        <li>
                            <div class="loc-icon">📍</div>
                            <div class="loc-text">
                                <strong>주소</strong>
                                <p>서울특별시 금천구 벚꽃로36길 30, KS타워 1동 8층 814호</p>
                            </div>
                        </li>
                        <li>
                            <div class="loc-icon">📞</div>
                            <div class="loc-text">
                                <strong>전화 & 이메일</strong>
                                <p>02-868-1068 (010-7268-1068)<br>ttmsoft@ttmsoft.co.kr (mhbaek93@naver.com)</p>
                            </div>
                        </li>
                        <li>
                            <div class="loc-icon">🚇</div>
                            <div class="loc-text">
                                <strong>지하철 이용시</strong>
                                <p>1호선, 7호선 가산디지털단지역 5번 출구 (도보 5분)</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <footer>
        <p><span>(주)티티엠소프트</span> | 대표자명 : 백민호 | 사업자등록번호 : 210-81-63047</p>
        <p>주소 : 서울특별시 금천구 벚꽃로36길 30, KS타워 1동 8층 814호 (가산디지털단지역 5번 출구)</p>
        <p>전화 : <span>02-868-1068 (010-7268-1068)</span> | 이메일 : <span>ttmsoft@ttmsoft.co.kr (mhbaek93@naver.com)</span></p>
        <p style="margin-top:20px; color:#9CA3AF;">COPYRIGHTⓒTTMSOFT. ALL RIGHTS RESERVED.</p>
    </footer>
</template>
<script>
// jQuery를 사용하신다면 상단에 유지
window.$ = window.jQuery;

export default {
    name: 'App',
    data() {
        return {
        };
    },
    mounted() {
        this.initTTMProject();
        this.loadKakaoMap();
    },
    methods: {
        loadKakaoMap() {
            // 이미 실행 객체가 있다면 즉시 실행
            if (window.daum && window.daum.roughmap && typeof window.daum.roughmap.Lander === 'function') {
                this.renderMap();
                return;
            }

            const script = document.createElement('script');
            script.src = "https://ssl.daumcdn.net/dmaps/map_js_init/roughmapLoader.js";
            script.charset = "UTF-8";

            script.onload = () => {
                // [수정 포인트] Lander가 함수인지 주기적으로 체크하는 로직 추가
                const checkLander = setInterval(() => {
                    if (window.daum && window.daum.roughmap && typeof window.daum.roughmap.Lander === 'function') {
                        this.renderMap();
                        clearInterval(checkLander); // 객체가 확인되면 체크 중단
                    }
                }, 100); // 0.1초마다 확인

                // 최대 3초까지만 확인하고 중단 (무한 루프 방지)
                setTimeout(() => clearInterval(checkLander), 3000);
            };

            document.head.appendChild(script);
        },

        renderMap() {
            try {
                // Lander가 확실히 생성자인지 다시 한 번 체크 후 실행
                if (typeof window.daum.roughmap.Lander === 'function') {
                    new window.daum.roughmap.Lander({
                        "timestamp": "1771825024178",
                        "key": "i99kfj4qejo",
                        "mapHeight": "436"
                    }).render();
                }
            } catch (e) {
                console.error("카카오맵 렌더링 중 최종 오류:", e);
            }
        },

        initTTMProject() {
            // --- [추가] 탭 좌우 스크롤 그림자 효과 함수 ---
            const setupScrollFades = (containerId, wrapperId) => {
                const container = document.getElementById(containerId);
                const wrapper = document.getElementById(wrapperId);
                if (!container || !wrapper) return;

                const checkScroll = () => {
                    // 왼쪽으로 스크롤 가능 여부
                    if (container.scrollLeft > 0) wrapper.classList.add('can-scroll-left');
                    else wrapper.classList.remove('can-scroll-left');

                    // 오른쪽으로 스크롤 가능 여부
                    if (Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth - 2) {
                        wrapper.classList.remove('can-scroll-right');
                    } else {
                        wrapper.classList.add('can-scroll-right');
                    }
                };

                container.addEventListener('scroll', checkScroll);
                window.addEventListener('resize', checkScroll);
                checkScroll(); // 초기 실행
            };

            // 1. 헤더 스크롤 로직
            const header = document.getElementById('header');
            if (header) {
                window.addEventListener('scroll', () => {
                    if (window.scrollY > 50) header.classList.add('scrolled');
                    else header.classList.remove('scrolled');
                });
            }

            // 2. 햄버거 메뉴 및 모바일 네비게이션
            const hamburgerBtn = document.getElementById('hamburgerMenu');
            const mobileNav = document.getElementById('mobileNav');
            const mobileLinks = document.querySelectorAll('.mobile-link');
            const mToggleBtn = document.getElementById('mToggleBtn');
            const mDropdown = document.getElementById('mDropdown');

            if (hamburgerBtn && mobileNav) {
                hamburgerBtn.addEventListener('click', () => {
                    hamburgerBtn.classList.toggle('open');
                    mobileNav.classList.toggle('active');
                    document.body.style.overflow = mobileNav.classList.contains('active') ? 'hidden' : 'auto';
                });
            }

            if (mToggleBtn && mDropdown) {
                mToggleBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    mDropdown.classList.toggle('active');
                    mToggleBtn.textContent = mDropdown.classList.contains('active') ? '▲' : '▼';
                });
            }

            // 3. 모바일 링크 클릭 시 닫기 및 스크롤
            mobileLinks.forEach(link => {
                link.addEventListener('click', function (e) {
                    if (this.getAttribute('href').startsWith('#')) {
                        e.preventDefault();
                        if (hamburgerBtn) hamburgerBtn.classList.remove('open');
                        if (mobileNav) mobileNav.classList.remove('active');
                        document.body.style.overflow = 'auto';

                        const targetId = this.getAttribute('href');
                        const targetSection = document.querySelector(targetId);
                        if (targetSection) {
                            setTimeout(() => {
                                const offsetPosition = targetSection.offsetTop - 80;
                                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                            }, 300);
                        }
                    }
                });
            });

            // 4. PC 네비게이션 및 히어로 버튼 부드러운 스크롤
            document.querySelectorAll('.pc-nav a.main-link, .hero-btn, .scroll-indicator').forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    if (this.getAttribute('href').startsWith('#')) {
                        e.preventDefault();
                        const targetId = this.getAttribute('href');
                        const targetSection = document.querySelector(targetId);
                        if (targetSection) {
                            const offsetPosition = targetSection.offsetTop - 80;
                            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                        }
                    }
                });
            });

            // 5. AI 서브 링크 탭 연결 로직
            document.querySelectorAll('.ai-sub-link').forEach(link => {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    const targetTabId = this.getAttribute('data-tab');
                    const targetSection = document.getElementById('ai-solution');
                    if (targetSection) {
                        const offsetPosition = targetSection.offsetTop - 80;
                        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });

                        const targetBtn = document.querySelector(`.ai-tab-btn[data-target="${targetTabId}"]`);
                        if (targetBtn) targetBtn.click();
                    }

                    if (mobileNav && mobileNav.classList.contains('active')) {
                        if (hamburgerBtn) hamburgerBtn.classList.remove('open');
                        mobileNav.classList.remove('active');
                        document.body.style.overflow = 'auto';
                    }
                });
            });

            // 6. 스크롤 시 메뉴 활성화 (Scroll Spy)
            const sections = document.querySelectorAll('section');
            const navLinks = document.querySelectorAll('.pc-nav a.main-link, .mobile-link');
            window.addEventListener('scroll', () => {
                let current = '';
                sections.forEach(section => {
                    const sectionTop = section.offsetTop;
                    if (window.pageYOffset >= (sectionTop - 150)) {
                        current = section.getAttribute('id');
                    }
                });

                navLinks.forEach(link => {
                    link.classList.remove('active');
                    if (link.getAttribute('href').includes(current)) {
                        link.classList.add('active');
                    }
                });
            });

            // 7. 탭 시스템 함수 선언
            const setupTabs = (tabBtnSelector, contentSelector, isScrollable = false, containerId = null) => {
                const tabs = document.querySelectorAll(tabBtnSelector);
                tabs.forEach(tab => {
                    tab.addEventListener('click', function (e) {
                        e.preventDefault();
                        const parentGroup = this.closest('.container') || this.closest('section');
                        if (!parentGroup) return;

                        const groupTabs = parentGroup.querySelectorAll(tabBtnSelector);
                        const groupContents = parentGroup.querySelectorAll(contentSelector);

                        groupTabs.forEach(btn => btn.classList.remove('active'));
                        groupContents.forEach(content => content.classList.remove('active'));

                        this.classList.add('active');
                        const targetId = this.getAttribute('data-target');
                        const targetEl = document.getElementById(targetId);
                        if (targetEl) targetEl.classList.add('active');

                        if (isScrollable && containerId) {
                            const container = document.getElementById(containerId);
                            if (container) {
                                const scrollLeft = this.offsetLeft - (container.clientWidth / 2) + (this.clientWidth / 2);
                                container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
                            }
                        }
                    });
                });
            };

            // 탭 실행
            setupTabs('#about-tabs .sub-tab-btn', '#about .about-content');
            setupTabs('#aiTabs .ai-tab-btn', '#ai-solution .ai-detail');
            setupTabs('#bizTabs .biz-tab-btn', '#business .biz-detail', true, 'bizTabs');

            // --- [추가] 8. 스크롤 페이드 효과 실행 ---
            setupScrollFades('bizTabs', 'bizTabWrapper');
            setupScrollFades('aiTabs', 'aiTabWrapper');

            // 9. Intersection Observer (애니메이션)
            const observerOptions = { root: null, rootMargin: '0px', threshold: 0.15 };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            document.querySelectorAll('.reveal-up, .reveal-left, .reveal-right, .reveal-scale').forEach(el => observer.observe(el));

            // 10. 플로팅 버튼 로직
            const floatingTabBtn = document.getElementById('floatingTabBtn');
            const aiSectionNode = document.getElementById('ai-solution');
            const aiTabsWrapperNode = document.getElementById('aiTabWrapper');

            if (floatingTabBtn && aiSectionNode) {
                window.addEventListener('scroll', () => {
                    const tabsBottomPosition = aiTabsWrapperNode.getBoundingClientRect().bottom + window.scrollY;
                    const sectionBottom = aiSectionNode.offsetTop + aiSectionNode.offsetHeight;
                    const currentScroll = window.scrollY;
                    const isMobile = window.innerWidth <= 768;

                    if (currentScroll > tabsBottomPosition + (isMobile ? -60 : -70) && currentScroll < sectionBottom - (isMobile ? 700 : 800)) {
                        floatingTabBtn.classList.add('show');
                    } else {
                        floatingTabBtn.classList.remove('show');
                    }
                });

                floatingTabBtn.addEventListener('click', () => {
                    const headerOffset = window.innerWidth <= 768 ? 60 : 70;
                    const targetPos = aiSectionNode.offsetTop - headerOffset;
                    window.scrollTo({ top: targetPos, behavior: 'smooth' });
                });
            }

            // 11. 마키 박스 색상 및 마우스 효과
            const applyElegantColors = () => {
                const tracks = document.querySelectorAll('.marquee-track');
                const elegantColors = ['#1E40AF', '#4338CA', '#6D28D9', '#312E81'];

                tracks.forEach(track => {
                    const boxes = Array.from(track.children);
                    const halfCount = boxes.length / 2;

                    for (let i = 0; i < halfCount; i++) {
                        const color = elegantColors[i % elegantColors.length];
                        const setupBox = (el) => {
                            if (!el) return;
                            el.style.backgroundColor = `${color}E6`;
                            el.onmouseenter = () => { el.style.backgroundColor = color; };
                            el.onmouseleave = () => { el.style.backgroundColor = `${color}E6`; };
                        };
                        setupBox(boxes[i]);
                        setupBox(boxes[i + halfCount]);
                    }
                });
            };

            // 렌더링 타이밍을 위해 약간의 지연 후 실행
            setTimeout(applyElegantColors, 100);
        }
    }

};
</script>